import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
    MatIconRegistry,
    MatSnackBar, MatTabGroup,
    MatTreeNestedDataSource
} from '@angular/material';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {environment} from '../../environments/environment';
import {NestedTreeControl} from '../../../node_modules/@angular/cdk/tree';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {DialogData} from '../partner-onboard/partner-onboard.component';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import * as CanvasJS from 'src/assets/js/canvasjs.min';
import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {Color, Label} from 'ng2-charts';
import {AppComponent} from '../app.component';
import {KongService} from '../kong.service';
import {logger} from 'codelyzer/util/logger';
import {ListenerService} from '../listener.service';
import {
    DatadogMetricsComponent,
    LeftpanelComponent,
    LoaderWithProgressComponent,
} from '../leftpanel/leftpanel.component';
import {async} from 'rxjs-compat/scheduler/async';
import {TourStep} from 'ngx-guided-tour/lib/guided-tour.constants';
import {Orientation} from 'ngx-guided-tour';
import {PromoteToEnvironmentComponent} from '../leftpanel/leftpanel.component';
import {error} from 'selenium-webdriver';
import {saveAs} from 'file-saver';
import JSZip from 'jszip';

declare let $;

export interface PeriodicElement {
    name: string;
    position: number;
    weight: number;
    symbol: string;
    description: string;
}

export interface EntityDashboardElement {
    partner: string;
    account_id: string;
    api: string;
    version: string;
    rows: number;
    duration: number;
    sla: number;
    billAmount: number;
}

@Component({
    selector: 'app-manage-entities',
    styleUrls: ['./manage-entities.component.css'],
    templateUrl: './manage-entities.component.html',
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})


export class ManageEntitiesComponent implements OnInit {
    @ViewChild('testsuite') testsuite: MatTabGroup;
    selectedTab = 0;
    items: any;
    apiKey: any; // = localStorage.getItem('apikey');
    partnerData: any;
    apiKeys: any;
    apiKeyData: any;
    entityVersions: any;
    itemList = [];
    applicationFilterList = [];
    b2bArray: any;
    //columns = ['APIs', 'Version', 'SLA (%)', 'Duration(Hrs)', 'End Points'];
    columns = ['API Name', 'API Version', 'Published', 'Public Access', 'OAuth 2.0', 'Created', 'Last Updated', 'Test Suite', 'Metrics', 'End Points'];
    // columnSearch = ['APIs', 'Version'];
    columnSearch = ['entityname', 'version', 'published', '', '', '', '', '', ''];
    columnSearchApplication = ['title', 'version', '', ''];
    entityMappingToSort = ['entityname', 'version', '', '', '', 'creationTime', 'lastModifiedTime', '', ''];

    applicationColumns = ['Application Title', 'Version', 'Created', 'Last Updated'];
    entityMappingToSortApplications = ['title', 'version', 'creationTime', 'lastModifiedTime'];
    // settings = {text: 'Select attribute(s) to search instantly'};
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    dmnExecutors: any;
    filterData: any[];
    applicationFilterData: any[];
    searchText: string;
    applicationSearchText: string;
    countPartnerEntities: any;
    maxCount: any;
    getStarted = [
        {
            'title': 'Generate and Launch API',
            'displayIcon': '/assets/img/generatelaunch.png',
            'description': 'This is a short description about our page',
            'routeLink': '/dataaccessapi',
            'buttonText': 'Create API'
        },
        {
            'title': 'Query Builder',
            'displayIcon': '/assets/img/query-builder.png',
            'description': 'This is a short description about our page',
            'routeLink': '/querybuilder',
            'buttonText': 'Build Query'
        },
        {
            'title': 'Digital Transformer',
            'displayIcon': '/assets/img/digi-transformer.png',
            'description': 'This is a short description about our page',
            'routeLink': '/digital-transformer',
            'buttonText': 'Migrate Legacy Apps'
        },
        {
            'title': 'Data API Marketplace',
            'displayIcon': '/assets/img/marketplace.png',
            'description': 'This is a short description about our page',
            'routeLink': '/common-data-api',
            'buttonText': 'Browse APIs'
        }
    ];
    cloudWatchNoOfHits: any;
    countPartnerAccountEntities: any;
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    partnerKey = localStorage.getItem('partnerKey');
    entity: string;
    version: string;
    // url = environment.apihost;
    url = environment.konghost;
    gatewayUrl: any;
    //= (this.partner === this.account ? 'https://gateway.' + this.partner + '.apiplatform.io' : 'https://gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
    panelOpenState = true;

    api_data: EntityDashboardElement [];
    countEnable = false;
    DeleteEntityCheck = true;
    metrics = {};
    item = [];
    // apiKey = localStorage.getItem('apikey');
    cloudwatchMetrics: any;
    cloudwatchLatencyMetrics: any;
    treeControl = new NestedTreeControl<any>(node => node.subType);
    dataSource = new MatTreeNestedDataSource<any>();
    options1 = new JsonEditorOptions();


    attributes: any;
    operations: any;
    error = false;
    errorMessage: string;
    executors: any;
    apiExecutors: any;
    thirdPartyApiExecutors: any;
    sqlQueryExecutors: any;
    unifiedQueryExecutors: any;
    workFlowExecutors: any;
    testSuiteExecutors: any;
    plSqlExecutors: any;
    dataTransformationExecutors: any;
    applicationData: any;

    countOfApplications = 0;
    countOfBusinessLogicApis = 0;
    countOfWorkflowApis = 0;
    countOfSqlQueryApis = 0;
    countOfUnifiedQueryApis = 0;
    countOfTestSuiteApis = 0;
    countOfThirdPartyApis = 0;
    countOfApiExecutors = 0;
    countOfDataAccessServices = 0;
    countOfDmnApis = 0;
    countOfPlSqlApis = 0;
    countOfDataTransformationApis = 0;
    loading = true;

    cloudWatchLatency: any;
    public barChartOptions: ChartOptions = {
        responsive: true,
    };
    public barChartLabels: Label[] = [];
    public barChartLabelsLatency: Label[] = [];
    public barChartType: ChartType = 'bar';
    public barChartLegend = true;
    public barChartPlugins = [];

    public barChartData: ChartDataSets[] = [
        {data: [], label: 'No. of API Hits'}
    ];
    public barChartDataLatency: ChartDataSets[] = [
        {data: [], label: 'Average Response Time'}
    ];
    public barChartColors: Color[] = [
        {
            borderColor: 'black',
            backgroundColor: '#ffc14f',
        },
    ];

    totalNumberOfAPIs = 0;
    totalNumberOfPublicAPIs = 0;
    totalNumberOfPrivateAPIs = 0;
    totalNumberOfPublishedAPIs = 0;
    totalNumberOfUnpublishedAPIs = 0;
    calculatingAPIsCount = false;
    computedGraphs = [];

    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;

    hasChild = (_: number, node: any) => !!node.subType && node.subType.length > 0;

    constructor(private confPost: ConfService,
                private kong: KongService,
                private _service: ConnecttocrudService,
                public snackBar: MatSnackBar,
                private route: ActivatedRoute,
                private appComponent: AppComponent,
                private router: Router,
                private appComp: AppComponent,
                public platform: LeftpanelComponent,
                private leftPanelDataListener: ListenerService,
                public dialog: MatDialog, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {


        platform.dataDeleted.subscribe(response => {
            if (response && response.status && response.type === 'entity') {
                this.removeIndexInmfData(response.name, response.version);
            }
        });

        leftPanelDataListener.manageEntitiesUpdate.subscribe(response => {
            if (response && response === 'update') {
                // this.items = this.platform.listOfDataAccessServices[0]['accounts'];
                // this.metrics = this.platform.listOfDataAccessServices[0];
                // this.item = [];
                // this.platform.listOfDataAccessServices[0]['accounts'].forEach((account) => {
                //     account.categories.forEach((category) => {
                //         category.entities.forEach((entity) => {
                //             const ent = {};
                //             ent['category'] = category.category;
                //             ent['account_id'] = account.account_id;
                //             ent['APIs'] = entity;
                //             if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + ent['account_id'] + '=>' + this.getValue(ent['APIs']) + '=>' + this.getVersion(ent['APIs']))) {
                //                 this.item.push(ent);
                //             }
                //         });
                //     });
                // });

                this.totalNumberOfAPIs = 0;

                this.items = this.platform.listOfDataAccessServices;
                if (this.platform.listOfDataAccessServices) {
                    this.metrics['noOfApis'] = this.platform.listOfDataAccessServices.length;
                }
                this.item = [];
                if (this.platform.listOfDataAccessServices) {
                    this.platform.listOfDataAccessServices.forEach((ent) => {
                        if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + this.account + '=>' + ent['entityname'] + '=>' + ent['version'])) {
                            this.item.push(ent);
                        }
                    });
                }
                this.countOfDataAccessServices = this.item.length;
                this.apiExecutors = this.platform.apiExecutors;
                this.countOfApiExecutors = this.platform.countOfApiExecutors;
                this.executors = this.platform.businessLogicExecutors;
                this.countOfBusinessLogicApis = this.platform.countOfBusinessLogicApis;
                this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
                this.unifiedQueryExecutors = this.platform.unifiedQueryExecutors;
                this.countOfSqlQueryApis = this.platform.countOfSqlQueryApis;
                this.countOfUnifiedQueryApis = this.platform.countOfUnifiedQueryApis;
                this.thirdPartyApiExecutors = this.platform.thirdPartyApiExecutors;
                this.countOfThirdPartyApis = this.platform.countOfThirdPartyApis;
                this.testSuiteExecutors = this.platform.testSuiteExecutors;
                this.countOfTestSuiteApis = this.platform.countOfTestSuiteApis;
                this.workFlowExecutors = this.platform.workFlowExecutors;
                this.countOfWorkflowApis = this.platform.countOfWorkflowApis;
                this.countOfDataTransformationApis = this.platform.countOfDataTransformationApis;
                this.dmnExecutors = this.platform.dmnExecutors;
                this.countOfDmnApis = this.platform.countOfDmnApis;
                this.plSqlExecutors = this.platform.plsqlExecutors;
                this.countOfPlSqlApis = this.platform.countOfPlSqlApis;
                this.dataTransformationExecutors = this.platform.dataTransformationExecutors;
                this.calculateCountOfAPIs();
            } else if (response && response === 'application') {
                this.applicationData = this.platform.applicationData;
                this.countOfApplications = this.platform.countOfApplications;
            }
        });

        iconRegistry.addSvgIcon(
            'video',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/video.svg'));
        iconRegistry.addSvgIcon(
            'metrics',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/metrics.svg'));
    }

    tabChanged(event) {
        this.selectedTab = event.index;
    }

    calculateCountOfAPIs() {
        let totalAPIs = [];
        this.totalNumberOfPublicAPIs = 0;
        this.totalNumberOfPrivateAPIs = 0;
        this.totalNumberOfPublishedAPIs = 0;
        this.totalNumberOfUnpublishedAPIs = 0;

        if (this.item) {
            totalAPIs = totalAPIs.concat(this.item);
        }
        if (this.executors) {
            totalAPIs = totalAPIs.concat(this.executors);
        }
        if (this.sqlQueryExecutors) {
            totalAPIs = totalAPIs.concat(this.sqlQueryExecutors);
        }
        if (this.unifiedQueryExecutors) {
            totalAPIs = totalAPIs.concat(this.unifiedQueryExecutors);
        }
        if (this.thirdPartyApiExecutors) {
            totalAPIs = totalAPIs.concat(this.thirdPartyApiExecutors);
        }
        if (this.testSuiteExecutors) {
            totalAPIs = totalAPIs.concat(this.testSuiteExecutors);
        }
        if (this.workFlowExecutors) {
            totalAPIs = totalAPIs.concat(this.workFlowExecutors);
        }
        if (this.dmnExecutors) {
            totalAPIs = totalAPIs.concat(this.dmnExecutors);
        }
        if (this.plSqlExecutors) {
            totalAPIs = totalAPIs.concat(this.plSqlExecutors);
        }
        if (this.dataTransformationExecutors) {
            totalAPIs = totalAPIs.concat(this.dataTransformationExecutors);
        }
        this.totalNumberOfAPIs = totalAPIs.length;

        for (const api of totalAPIs) {
            if (api) {
                if (api['published'] === true) {
                    this.totalNumberOfPublishedAPIs += 1;
                    if (api['scopeOfAccess'] === 'public' || api['executor_scope'] === 'public') {
                        this.totalNumberOfPublicAPIs += 1;
                    } else {
                        this.totalNumberOfPrivateAPIs += 1;
                    }
                } else {
                    this.totalNumberOfUnpublishedAPIs += 1;
                    if (api['scopeOfAccess'] === 'public' || api['executor_scope'] === 'public') {
                        this.totalNumberOfPublicAPIs += 1;
                    } else {
                        this.totalNumberOfPrivateAPIs += 1;
                    }
                }
            }
        }
    }

    openDialog(partner, account, entity, version): void {
        const data = {};
        data['partner'] = partner;
        data['account'] = account;
        data['entity'] = entity;
        data['version'] = version;
        data['url'] = this.gatewayUrl;
        data['partnerKey'] = this.partnerKey;
        data['type'] = 'entity';
        const dialogRef = this.dialog.open(EndpointComponent, {
            width: '70%',
            height: '70%',
            data: data,
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    checkFilter() {
        if (!this.filterData || this.filterData === [] || this.filterData === null) {
            alert('Please select an attribute to filter.');
            this.searchText = '';
        }
    }

    checkApplicationFilter() {
        if (!this.applicationFilterData || this.applicationFilterData === [] || this.applicationFilterData === null) {
            alert('Please select an attribute to filter.');
            this.applicationSearchText = '';
        }
    }

    patchPluginInAPIGateway(id, plugin) {
        return new Promise((resolve, reject) => {
            this.kong.patchPluginInApiGateway(id, plugin).subscribe(response => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    configureIPRestrictionAndMakeItPublic(partner, account, entity, version, resp) {

        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
        });

        this.kong.getDefaultPlugins();
        this.kong.createPluginForServiceInGateway({name: partner + '-' + account + '-' + entity + '-' + version}, this.kong.ipRestriction, {}).then(serviceResp => {
            this.kong.getRoutesForAServiceFromApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(async routeResp => {
                if (routeResp) {
                    let gatewayRoute: any;
                    gatewayRoute = routeResp;
                    for (const route of gatewayRoute['data']) {
                        if (route) {
                            await this.kong.createPluginForRouteInGateway({name: route['name']}, this.kong.ipRestriction, {}).then(routePluginResp => {

                            }, error => {
                                if (error.status === 409) {
                                    this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async plugin => {
                                        if (plugin) {
                                            const pluginData = plugin;
                                            const id = pluginData.id;
                                            pluginData.enabled = false;
                                            await this.patchPluginInAPIGateway(id, pluginData);
                                        }
                                    });
                                }
                            });
                        }
                    }
                }
                loaderDialog.close();
                resp['scopeOfAccess'] = 'public';
                resp['published'] = true;
                const methods1 = [];
                if (resp && resp['methods']) {
                    for (const method of resp['methods']) {
                        if (method !== 'OPTIONS') {
                            methods1.push(method);
                        }
                    }
                    resp['methods'] = methods1;
                }
                resp['lastModifiedTime'] = Date.now();
                this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                    this.platform.updateAPIAuditLog(partner, account, resp['entityname'], resp['version'], 'DAAS', resp, resp);
                    this.platform.listOfDataAccessServices = null;
                    this.getCategoriesAndEntities();
                    this.platform.openSnackBar('API has been successfully configured with IP Restriction setting and made publicly accessible.', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }, error => {
                loaderDialog.close();
            });
        }, error => {
            loaderDialog.close();
        });
    }

    togglePublicAccess(event, partner, account, entity, version, resp) {
        this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(gatewayService => {
            if (gatewayService) {
                this.kong.getPluginsForServiceByPluginNameInApiGateway(gatewayService['name'], 'ip-restriction').subscribe(plugin => {
                    if (plugin) {
                        let pluginData = plugin;
                        const id = pluginData.id;
                        const publishdata = {};
                        publishdata['entity'] = entity;
                        publishdata['version'] = version;
                        publishdata['scopeOfAccess'] = resp['scopeOfAccess'];
                        publishdata['published'] = resp['published'];
                        publishdata['pluginData'] = pluginData;
                        const dialogRef = this.dialog.open(SecureApiConfirmationComponent, {
                            width: '60%',
                            data: publishdata
                        });
                        dialogRef.afterClosed().subscribe(async result => {
                            if (result === 'unsecure') {
                                // Disable IP Restriction Plugin
                                pluginData = publishdata['pluginData'];
                                pluginData.enabled = false;

                                await this.patchPluginInAPIGateway(id, pluginData);
                                this.kong.getRoutesForAServiceFromApiGateway(gatewayService['id']).subscribe(routeResp => {
                                    if (routeResp) {
                                        let gatewayRoute: any;
                                        gatewayRoute = routeResp;
                                        for (const route of gatewayRoute['data']) {
                                            if (route) {
                                                this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                                    if (routePlugin) {
                                                        const pluginData1 = routePlugin;
                                                        const id1 = pluginData1.id;
                                                        pluginData1.enabled = false;
                                                        await this.patchPluginInAPIGateway(id1, pluginData1);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                    resp['scopeOfAccess'] = 'public';
                                    resp['published'] = true;
                                    const methods = [];
                                    if (resp && resp['methods']) {
                                        for (const method of resp['methods']) {
                                            if (method !== 'OPTIONS') {
                                                methods.push(method);
                                            }
                                        }
                                        resp['methods'] = methods;
                                    }
                                    resp['lastModifiedTime'] = Date.now();
                                    this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                                        this.platform.updateAPIAuditLog(partner, account, resp['entityname'], resp['version'], 'DAAS', resp, resp);
                                        this.platform.listOfDataAccessServices = null;
                                        this.getCategoriesAndEntities();
                                        this.platform.openSnackBar('API has been provided the public access successfully.', 'Success', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }, updateError => {
                                        pluginData.enabled = true;
                                        this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                                            event.source.checked = !event.source.checked;
                                            this.platform.handleErrorGracefully(updateError, 'Error while providing public access to your API. Please try again after sometime');
                                        });
                                    });
                                });
                            } else if (result === 'secure') {
                                // Enable IP Restriction Plugin
                                pluginData = publishdata['pluginData'];
                                pluginData.enabled = true;

                                await this.patchPluginInAPIGateway(id, pluginData);
                                this.kong.getRoutesForAServiceFromApiGateway(gatewayService['id']).subscribe(routeResp => {
                                    if (routeResp) {
                                        let gatewayRoute: any;
                                        gatewayRoute = routeResp;
                                        for (const route of gatewayRoute['data']) {
                                            if (route) {
                                                this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                                    if (routePlugin) {
                                                        const pluginData1 = routePlugin;
                                                        const id1 = pluginData1.id;
                                                        pluginData1.enabled = true;
                                                        await this.patchPluginInAPIGateway(id1, pluginData1);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                    resp['scopeOfAccess'] = 'private';
                                    resp['published'] = true;
                                    const methods = [];
                                    if (resp && resp['methods']) {
                                        for (const method of resp['methods']) {
                                            if (method !== 'OPTIONS') {
                                                methods.push(method);
                                            }
                                        }
                                        resp['methods'] = methods;
                                    }
                                    resp['lastModifiedTime'] = Date.now();
                                    this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                                        this.platform.updateAPIAuditLog(partner, account, resp['entityname'], resp['version'], 'DAAS', resp, resp);
                                        this.platform.listOfDataAccessServices = null;
                                        this.getCategoriesAndEntities();
                                        this.platform.openSnackBar('API has been restricted for public access successfully.', 'Success', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }, updateError => {
                                        pluginData.enabled = false;
                                        this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                                            event.source.checked = !event.source.checked;
                                            this.platform.handleErrorGracefully(updateError, 'Error while restricting the public access for your API. Please try again after sometime');
                                        });
                                    });
                                });
                            } else {
                                event.source.checked = !event.source.checked;
                            }
                        });
                    } else {
                        // NO PLUGIN
                        this.configureIPRestrictionAndMakeItPublic(partner, account, entity, version, resp);
                        // event.source.checked = !event.source.checked;
                    }
                });
            } else {
                const dialogRef1 = this.dialog.open(CreateGatewayResourceConfirmationComponent, {
                    width: '60%',
                    height: 'auto',
                    data: {
                        entity: entity,
                        version: version
                    }
                });
                dialogRef1.afterClosed().subscribe(result => {
                    this.configureDefaultGatewaySettings(partner, account, entity, version, resp, event, result);
                });
                // event.source.checked = !event.source.checked;
            }
        }, error => {
            if (error.status === 404) {
                const dialogRef1 = this.dialog.open(CreateGatewayResourceConfirmationComponent, {
                    width: '60%',
                    height: 'auto',
                    data: {
                        entity: entity,
                        version: version
                    }
                });
                dialogRef1.afterClosed().subscribe(result => {
                    this.configureDefaultGatewaySettings(partner, account, entity, version, resp, event, result);
                });
            }
        });
    }

    getDefaultControlPlaneTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: 'Welcome ' + localStorage.getItem('signInEmail'),
            content: this.platform.getProperty('GT_WELCOME_USER_CONTENT'),
        });
        return steps;
    }

    getControlPlaneTourSteps(): Array<TourStep> {

        let steps: TourStep[] = [];

        if (this.totalNumberOfAPIs === 0) {
            steps.push({
                title: 'Welcome ' + localStorage.getItem('signInEmail'),
                content: this.platform.getProperty('GT_WELCOME_USER_CONTENT'),
            }, {
                content: this.platform.getProperty('GT_CONTROL_PLANE_NO_APIS_CONTENT'),
            });
        } else {

            steps.push({
                title: 'Welcome ' + localStorage.getItem('signInEmail'),
                content: this.platform.getProperty('GT_WELCOME_USER_CONTENT'),
            });


            steps.push({
                title: this.platform.getProperty('GT_CONTROL_PLANE_NO_OF_APIS_TITLE'),
                selector: '.tour-control-plane-no-of-apis',
                content: this.platform.getProperty('GT_CONTROL_PLANE_NO_OF_APIS_CONTENT'),
                orientation: Orientation.Bottom,
                action: (() => {
                    $('.tour-control-plane-no-of-apis')[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
                })

            }, {
                title: this.platform.getProperty('GT_CONTROL_PLANE_NO_OF_PUBLISHED_APIS_TITLE'),
                selector: '.tour-control-plane-no-of-published-apis',
                content: this.platform.getProperty('GT_CONTROL_PLANE_NO_OF_PUBLISHED_APIS_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.platform.getProperty('GT_CONTROL_PLANE_DATA_STORAGE_TITLE'),
                selector: '.tour-control-plane-data-storage',
                content: this.platform.getProperty('GT_CONTROL_PLANE_DATA_STORAGE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.platform.getProperty('GT_CONTROL_PLANE_FILE_STORAGE_TITLE'),
                selector: '.tour-control-plane-file-storage',
                content: this.platform.getProperty('GT_CONTROL_PLANE_FILE_STORAGE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.platform.getProperty('GT_CONTROL_PLANE_API_HITS_CHART_TITLE'),
                selector: '.tour-control-plane-api-hits-chart',
                content: this.platform.getProperty('GT_CONTROL_PLANE_API_HITS_CHART_CONTENT'),
                orientation: Orientation.Right
            }, {
                title: this.platform.getProperty('GT_CONTROL_PLANE_API_RESPONSE_TIME_CHART_TITLE'),
                selector: '.tour-control-plane-average-response-time-chart',
                content: this.platform.getProperty('GT_CONTROL_PLANE_API_RESPONSE_TIME_CHART_CONTENT'),
                orientation: Orientation.Left
            });

            if (this.countOfBusinessLogicApis === 0 && this.countOfSqlQueryApis === 0 && this.countOfUnifiedQueryApis === 0 && this.countOfTestSuiteApis === 0
                && this.countOfThirdPartyApis === 0) {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_DAAS_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_DAAS_TAB_CONTENT'),
                    orientation: Orientation.Top,
                    action: (() => {
                        this.selectedTab = 0;
                        // $('.tour-control-plan-api-tabs')[0].scrollIntoView({ behavior: 'smooth', block: 'nearest'});
                    })
                }, {
                    title: this.platform.getProperty('GT_DAAS_INTRO_TITLE'),
                    selector: '.tour-control-plane-daas-create',
                    content: this.platform.getProperty('GT_DAAS_INTRO_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_FILTERS_TITLE'),
                    selector: '.tour-control-plane-search-filter',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_FILTERS_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_TITLE'),
                    selector: '.tour-control-plane-search-input',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_CONTENT'),
                    orientation: Orientation.TopRight
                });


                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_EDIT_API_TITLE'),
                    selector: '.tour-control-plane-edit-api',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_EDIT_API_CONTENT'),
                    orientation: Orientation.TopLeft,
                    action: (() => {
                        $('.tour-control-plane-edit-api')[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
                    })
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_API_MANAGEMENT_TITLE'),
                    selector: '.tour-control-plane-api-management',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_API_MANAGEMENT_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_API_PROMOTION_TITLE'),
                    selector: '.tour-control-plane-api-promotion',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_API_PROMOTION_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_API_DOCUMENTATION_TITLE'),
                    selector: '.tour-control-plane-api-documentation',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_API_DOCUMENTATION_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_API_GRANT_ACCESS_TITLE'),
                    selector: '.tour-control-plane-api-grant-access',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_API_GRANT_ACCESS_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_DELETE_API_TITLE'),
                    selector: '.tour-control-plane-delete-api',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_DELETE_API_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_API_NAME_TITLE'),
                    selector: '.tour-control-plane-api-name',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_API_NAME_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_API_VERSION_TITLE'),
                    selector: '.tour-control-plane-api-version',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_API_VERSION_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('PUBLISH_API_TITLE'),
                    selector: '.tour-control-plane-publish',
                    content: this.platform.getProperty('PUBLISH_API_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('API_ACCESS_POLICY_TITLE'),
                    selector: '.tour-control-plane-publish-policy',
                    content: this.platform.getProperty('API_ACCESS_POLICY_CONTENT'),
                    orientation: Orientation.TopLeft
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_CREATION_TIME_TITLE'),
                    selector: '.tour-control-plane-creation-time',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_CREATION_TIME_CONTENT'),
                    orientation: Orientation.TopRight
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_LAST_UPDATED_TITLE'),
                    selector: '.tour-control-plane-last-modified',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_LAST_UPDATED_CONTENT'),
                    orientation: Orientation.TopRight
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_API_METRICS_TITLE'),
                    selector: '.tour-control-plane-api-metrics',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_API_METRICS_CONTENT'),
                    orientation: Orientation.TopRight
                }, {
                    title: this.platform.getProperty('GT_CONTROL_PLANE_API_ENDPOINTS_TITLE'),
                    selector: '.tour-control-plane-api-end-points',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_API_ENDPOINTS_CONTENT'),
                    orientation: Orientation.TopRight
                });
            } else {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_DAAS_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_DAAS_TAB_CONTENT'),
                    orientation: Orientation.Top
                    // action: (() => {
                    //     $('.tour-control-plan-api-tabs')[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
                    // })
                });
            }


            steps.push({
                title: this.platform.getProperty('GT_CONTROL_PLANE_DAAS_EXECUTORS_TAB_TITLE'),
                selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(2)',
                content: this.platform.getProperty('GT_CONTROL_PLANE_DAAS_EXECUTORS_TAB_CONTENT'),
                orientation: Orientation.Top
                // ,action: (() => {
                //     this.selectedTab = 1;
                // })
            });
            // steps.push({
            //     title: this.platform.getProperty('GT_DAAS_INTRO_TITLE'),
            //     selector: '.tour-control-plane-daas-create',
            //     content: this.platform.getProperty('GT_DAAS_INTRO_CONTENT'),
            //     orientation: Orientation.Right
            // }, {
            //     title: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_FILTERS_TITLE'),
            //     selector: '.tour-control-plane-search-filter',
            //     content: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_FILTERS_CONTENT'),
            //     orientation: Orientation.Right
            // }, {
            //     title: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_TITLE'),
            //     selector: '.tour-control-plane-search-input',
            //     content: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_CONTENT'),
            //     orientation: Orientation.Left
            // });

            // steps.push({
            //     title: this.platform.getProperty('GT_CONTROL_PLANE_BUSINESS_LOGIC_API_TAB_TITLE'),
            //     selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3)',
            //     content: this.platform.getProperty('GT_CONTROL_PLANE_BUSINESS_LOGIC_API_TAB_TITLE'),
            //     orientation: Orientation.Top,
            //     action: (() => {
            //         this.selectedTab = 2;
            //     })
            // });

            if (this.countOfBusinessLogicApis > 0) {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_BUSINESS_LOGIC_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_BUSINESS_LOGIC_API_TAB_TITLE'),
                    orientation: Orientation.Top,
                    action: (() => {
                        this.selectedTab = 2;
                    })
                }, {
                    title: this.platform.getProperty('GT_BUSINESS_LOGIC_INTRO_TITLE'),
                    selector: '.tour-control-plane-business-logic-create',
                    content: this.platform.getProperty('GT_BUSINESS_LOGIC_INTRO_CONTENT'),
                    orientation: Orientation.TopLeft
                });

                steps = steps.concat(this.getExecutorTourSteps());
            } else {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_BUSINESS_LOGIC_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_BUSINESS_LOGIC_API_TAB_TITLE'),
                    orientation: Orientation.Top
                });
            }

            // steps.push({
            //     title: this.platform.getProperty('GT_CONTROL_PLANE_THIRD_PARTY_API_TAB_TITLE'),
            //     selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(4)',
            //     content: this.platform.getProperty('GT_CONTROL_PLANE_THIRD_PARTY_API_TAB_CONTENT'),
            //     orientation: Orientation.Top
            //     // action: (() => {
            //     //     this.selectedTab = 3;
            //     // })
            // });
            if (this.countOfBusinessLogicApis === 0 && this.countOfThirdPartyApis > 0 && this.countOfSqlQueryApis === 0 && this.countOfUnifiedQueryApis === 0 && this.countOfTestSuiteApis === 0) {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_THIRD_PARTY_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(4)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_THIRD_PARTY_API_TAB_CONTENT'),
                    orientation: Orientation.Top,
                    action: (() => {
                        this.selectedTab = 3;
                    })
                }, {
                    title: this.platform.getProperty('GT_THIRD_PARTY_API_INTRO_TITLE'),
                    selector: '.tour-control-plane-third-party-create',
                    content: this.platform.getProperty('GT_THIRD_PARTY_API_INTRO_CONTENT'),
                    orientation: Orientation.TopLeft
                });

                steps = steps.concat(this.getExecutorTourSteps());
            } else {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_THIRD_PARTY_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(4)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_THIRD_PARTY_API_TAB_CONTENT'),
                    orientation: Orientation.Top
                });
            }

            if (this.countOfBusinessLogicApis === 0 && this.countOfSqlQueryApis > 0) {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_QUERY_BUILDER_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(5)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_QUERY_BUILDER_API_TAB_CONTENT'),
                    orientation: Orientation.Top,
                    action: (() => {
                        this.selectedTab = 4;
                    })
                });
                steps.push({
                    title: this.platform.getProperty('GT_QUERY_BUILDER_INTRO_TITLE'),
                    selector: '.tour-control-plane-sql-query-create',
                    content: this.platform.getProperty('GT_QUERY_BUILDER_INTRO_CONTENT'),
                    orientation: Orientation.TopLeft
                });

                steps = steps.concat(this.getExecutorTourSteps());
            } else {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_QUERY_BUILDER_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(5)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_QUERY_BUILDER_API_TAB_CONTENT'),
                    orientation: Orientation.Top
                });
            }

            if (this.countOfBusinessLogicApis === 0 && this.countOfUnifiedQueryApis > 0) {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_QUERY_BUILDER_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(5)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_QUERY_BUILDER_API_TAB_CONTENT'),
                    orientation: Orientation.Top,
                    action: (() => {
                        this.selectedTab = 5;
                    })
                });
                steps.push({
                    title: this.platform.getProperty('GT_QUERY_BUILDER_INTRO_TITLE'),
                    selector: '.tour-control-plane-sql-query-create',
                    content: this.platform.getProperty('GT_QUERY_BUILDER_INTRO_CONTENT'),
                    orientation: Orientation.TopLeft
                });

                steps = steps.concat(this.getExecutorTourSteps());
            } else {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_QUERY_BUILDER_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(5)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_QUERY_BUILDER_API_TAB_CONTENT'),
                    orientation: Orientation.Top
                });
            }

            if (this.countOfBusinessLogicApis === 0 && this.countOfSqlQueryApis === 0 && this.countOfTestSuiteApis > 0) {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_TEST_SUITE_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(6)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_TEST_SUITE_API_TAB_CONTENT'),
                    orientation: Orientation.Top,
                    action: (() => {
                        this.selectedTab = 6;
                    })
                });
                steps.push({
                    title: this.platform.getProperty('GT_TEST_SUITE_INTRO_TITLE'),
                    selector: '.tour-control-plane-test-suite-create',
                    content: this.platform.getProperty('GT_TEST_SUITE_INTRO_CONTENT'),
                    orientation: Orientation.TopLeft
                });

                steps = steps.concat(this.getExecutorTourSteps());
            } else {
                steps.push({
                    title: this.platform.getProperty('GT_CONTROL_PLANE_TEST_SUITE_API_TAB_TITLE'),
                    selector: '.tour-control-plan-api-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(6)',
                    content: this.platform.getProperty('GT_CONTROL_PLANE_TEST_SUITE_API_TAB_CONTENT'),
                    orientation: Orientation.Top,
                    closeAction: (() => {
                        this.selectedTab = 0;
                        $('.tour-control-plane-no-of-apis')[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
                    })
                });
            }
        }

        return steps;
    }

    getExecutorTourSteps(): Array<TourStep> {
        const steps: TourStep[] = [];

        steps.push({
            title: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_FILTERS_TITLE'),
            selector: '.tour-control-plane-search-filter',
            content: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_FILTERS_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_TITLE'),
            selector: '.tour-control-plane-search-input',
            content: this.platform.getProperty('GT_CONTROL_PLANE_SEARCH_CONTENT'),
            orientation: Orientation.TopRight
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_EDIT_API_TITLE'),
            selector: '.tour-control-plane-edit-executor',
            content: this.platform.getProperty('GT_CONTROL_PLANE_EDIT_API_CONTENT'),
            orientation: Orientation.TopLeft,
            action: (() => {
                $('.tour-control-plane-edit-executor')[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
            })
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_API_MANAGEMENT_TITLE'),
            selector: '.tour-control-plane-api-management',
            content: this.platform.getProperty('GT_CONTROL_PLANE_API_MANAGEMENT_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_API_PROMOTION_TITLE'),
            selector: '.tour-control-plane-api-promotion',
            content: this.platform.getProperty('GT_CONTROL_PLANE_API_PROMOTION_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_API_DOCUMENTATION_TITLE'),
            selector: '.tour-control-plane-api-documentation',
            content: this.platform.getProperty('GT_CONTROL_PLANE_API_DOCUMENTATION_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_API_SCHEDULE_TITLE'),
            selector: '.tour-control-plane-schedule-executor',
            content: this.platform.getProperty('GT_CONTROL_PLANE_API_SCHEDULE_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_API_GRANT_ACCESS_TITLE'),
            selector: '.tour-control-plane-api-grant-access',
            content: this.platform.getProperty('GT_CONTROL_PLANE_API_GRANT_ACCESS_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_DELETE_API_TITLE'),
            selector: '.tour-control-plane-delete-api',
            content: this.platform.getProperty('GT_CONTROL_PLANE_DELETE_API_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_EXECUTOR_METHOD_TITLE'),
            selector: '.tour-control-plane-executor-method',
            content: this.platform.getProperty('GT_CONTROL_PLANE_EXECUTOR_METHOD_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_EXECUTOR_NAME_TITLE'),
            selector: '.tour-control-plane-executor-name',
            content: this.platform.getProperty('GT_CONTROL_PLANE_EXECUTOR_NAME_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_EXECUTOR_VERSION_TITLE'),
            selector: '.tour-control-plane-executor-version',
            content: this.platform.getProperty('GT_CONTROL_PLANE_EXECUTOR_VERSION_CONTENT'),
            orientation: Orientation.TopRight
        }, {
            title: this.platform.getProperty('PUBLISH_API_TITLE'),
            selector: '.tour-control-plane-publish',
            content: this.platform.getProperty('PUBLISH_API_CONTENT'),
            orientation: Orientation.TopRight
        }, {
            title: this.platform.getProperty('API_ACCESS_POLICY_TITLE'),
            selector: '.tour-control-plane-publish-policy',
            content: this.platform.getProperty('API_ACCESS_POLICY_CONTENT'),
            orientation: Orientation.TopLeft
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_CREATION_TIME_TITLE'),
            selector: '.tour-control-plane-creation-time',
            content: this.platform.getProperty('GT_CONTROL_PLANE_CREATION_TIME_CONTENT'),
            orientation: Orientation.Top
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_LAST_UPDATED_TITLE'),
            selector: '.tour-control-plane-last-modified',
            content: this.platform.getProperty('GT_CONTROL_PLANE_LAST_UPDATED_CONTENT'),
            orientation: Orientation.Top
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_API_METRICS_TITLE'),
            selector: '.tour-control-plane-api-metrics',
            content: this.platform.getProperty('GT_CONTROL_PLANE_API_METRICS_CONTENT'),
            orientation: Orientation.TopRight
        }, {
            title: this.platform.getProperty('GT_CONTROL_PLANE_API_ENDPOINTS_TITLE'),
            selector: '.tour-control-plane-api-end-points',
            content: this.platform.getProperty('GT_CONTROL_PLANE_API_ENDPOINTS_CONTENT'),
            orientation: Orientation.TopRight
        });

        return steps;
    }

    configureDefaultGatewaySettings(partner, account, entity, version, resp, event, result) {
        const logTimeStamp = Date.now();
        if (result === 'configure') {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                width: 'auto',
                height: 'auto',
                data: {
                    message: ''
                }
            });
            this.kong.configureApiGatewayWithIpRestrictionWithMethods(partner, account, entity, version, false, false, resp['methods'], logTimeStamp, '').then(response => {
                const methods = [];
                if (resp && resp['methods']) {
                    for (const method of resp['methods']) {
                        if (method !== 'OPTIONS') {
                            methods.push(method);
                        }
                    }
                    resp['methods'] = methods;
                }
                resp['published'] = true;
                resp['scopeOfAccess'] = 'public';
                resp['lastModifiedTime'] = Date.now();
                this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                    loaderDialog.close();
                    const dialogRef2 = this.dialog.open(ModeOfAccessConfirmationComponent, {
                        width: '60%',
                        height: 'auto',
                        disableClose: true
                    });
                    dialogRef2.afterClosed().subscribe(result1 => {
                        if (result1 === 'public') {
                            resp['scopeOfAccess'] = 'public';
                            resp['published'] = true;
                            const methods1 = [];
                            if (resp && resp['methods']) {
                                for (const method of resp['methods']) {
                                    if (method !== 'OPTIONS') {
                                        methods1.push(method);
                                    }
                                }
                                resp['methods'] = methods1;
                            }
                            resp['lastModifiedTime'] = Date.now();
                            this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                                this.platform.updateAPIAuditLog(partner, account, resp['entityname'], resp['version'], 'DAAS', resp, resp);
                                this.platform.listOfDataAccessServices = null;
                                this.getCategoriesAndEntities();
                                this.platform.openSnackBar('API has been provided the public access successfully.', 'Success', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            });
                        } else if (result1 === 'private') {
                            this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(gatewayService1 => {
                                if (gatewayService1) {
                                    this.kong.getPluginsForServiceByPluginNameInApiGateway(gatewayService1['name'], 'ip-restriction').subscribe(async plugin => {
                                        if (plugin) {
                                            const pluginData = plugin;
                                            const id = pluginData.id;
                                            pluginData.enabled = true;

                                            await this.patchPluginInAPIGateway(id, pluginData);
                                            this.kong.getRoutesForAServiceFromApiGateway(gatewayService1['id']).subscribe(routeResp => {
                                                if (routeResp) {
                                                    let gatewayRoute: any;
                                                    gatewayRoute = routeResp;
                                                    for (const route of gatewayRoute['data']) {
                                                        if (route) {
                                                            this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                                                if (routePlugin) {
                                                                    const pluginData1 = routePlugin;
                                                                    const id1 = pluginData1.id;
                                                                    pluginData1.enabled = true;
                                                                    await this.patchPluginInAPIGateway(id1, pluginData1);
                                                                }
                                                            });
                                                        }
                                                    }
                                                }
                                                resp['scopeOfAccess'] = 'private';
                                                resp['published'] = true;
                                                const methods1 = [];
                                                if (resp && resp['methods']) {
                                                    for (const method of resp['methods']) {
                                                        if (method !== 'OPTIONS') {
                                                            methods1.push(method);
                                                        }
                                                    }
                                                    resp['methods'] = methods1;
                                                }
                                                resp['lastModifiedTime'] = Date.now();
                                                this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                                                    this.platform.updateAPIAuditLog(partner, account, resp['entityname'], resp['version'], 'DAAS', resp, resp);
                                                    this.platform.listOfDataAccessServices = null;
                                                    this.getCategoriesAndEntities();
                                                    this.platform.openSnackBar('API has been restricted for public access successfully.', 'Success', {
                                                        duration: 5000,
                                                        verticalPosition: 'top',
                                                        horizontalPosition: 'center'
                                                    });
                                                }, updateError => {
                                                    pluginData.enabled = false;
                                                    this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                                                        event.source.checked = !event.source.checked;
                                                        this.platform.handleErrorGracefully(updateError, 'Error while restricting the public access for your API. Please try again after sometime');
                                                    });
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }, error => {
                    loaderDialog.close();
                });
            }, error => {
                event.source.checked = !event.source.checked;
                loaderDialog.close();
                this.platform.openSnackBar('Error while configuring gateway settings for your API. Please try again after sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            event.source.checked = !event.source.checked;
        }
    }

    openScopeOfAccessConfirmationDialog(event, partner, account, entity, version, item): void {

        const entityLoader = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
            data: {
                message: ''
            }
        });
        this.confPost.getEntityForPartner(partner, account, localStorage.getItem('partnerKey'), entity, version).subscribe(resp => {
            if (resp) {
                entityLoader.close();
                const status = resp['scopeOfAccess'];
                this.togglePublicAccess(event, partner, account, entity, version, resp);
            } else {
                event.source.checked = !event.source.checked;
                entityLoader.close();
                this.platform.openSnackBar('Error while retrieving your API. Please try again after sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            event.source.checked = !event.source.checked;
            entityLoader.close();
            this.platform.handleErrorGracefully(error, 'Error while retrieving your API. Please try again after sometime');
        });
    }

    openPublishConfirmationDialog(event, partner, account, entity, version, item) {

        const entityLoader = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
            data: {
                message: ''
            }
        });

        return new Promise((resolve, reject) => {
            const logTimeStamp = Date.now();
            this.confPost.getEntityForPartner(partner, account, localStorage.getItem('partnerKey'), entity, version).subscribe(resp => {
                entityLoader.close();
                if (resp) {
                    const publishdata = {};
                    publishdata['entity'] = entity;
                    publishdata['version'] = version;
                    publishdata['published'] = resp['published'];
                    publishdata['scopeOfAccess'] = resp['scopeOfAccess'];
                    const dialogRef = this.dialog.open(PublishServiceConfirmationComponent, {
                        width: '60%',
                        data: publishdata
                    });
                    dialogRef.afterClosed().subscribe(result => {
                        if (result === 'publish') {
                            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                                width: 'auto',
                                height: 'auto',
                                // data: {
                                //     message: 'Publishing your API.... Please kindly wait   '
                                // }
                            });
                            this.kong.configureApiGatewayWithIpRestrictionWithMethods(partner, account, entity, version, resp['scopeOfAccess'] !== 'public', false, resp['methods'], logTimeStamp, '').then(response => {
                                resp['published'] = true;
                                resp['scopeOfAccess'] = 'private';
                                const methods = [];
                                if (resp && resp['methods']) {
                                    for (const method of resp['methods']) {
                                        if (method !== 'OPTIONS') {
                                            methods.push(method);
                                        }
                                    }
                                    resp['methods'] = methods;
                                }
                                resp['lastModifiedTime'] = Date.now();

                                this.confPost.updateEntity(partner, account, resp).subscribe(updateResp1 => {
                                    this.kong.getPluginsForServiceByPluginNameInApiGateway(partner + '-' + account + '-' + entity + '-' + version, 'ip-restriction').subscribe(plugin => {
                                        if (plugin) {
                                            let pluginData = plugin;
                                            const id = pluginData.id;
                                            const publishdata1 = {};
                                            publishdata1['entity'] = entity;
                                            publishdata1['version'] = version;
                                            publishdata1['scopeOfAccess'] = resp['scopeOfAccess'];
                                            publishdata1['published'] = resp['published'];
                                            publishdata1['pluginData'] = pluginData;
                                            const dialogRef1 = this.dialog.open(SecureApiConfirmationComponent, {
                                                width: '60%',
                                                data: publishdata
                                            });
                                            dialogRef1.afterClosed().subscribe(async result1 => {
                                                if (result1 === 'unsecure') {
                                                    // Disable IP Restriction Plugin
                                                    pluginData = publishdata1['pluginData'];
                                                    pluginData.enabled = false;

                                                    await this.patchPluginInAPIGateway(id, pluginData);
                                                    this.kong.getRoutesForAServiceFromApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(routeResp => {
                                                        if (routeResp) {
                                                            let gatewayRoute: any;
                                                            gatewayRoute = routeResp;
                                                            for (const route of gatewayRoute['data']) {
                                                                if (route) {
                                                                    this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                                                        if (routePlugin) {
                                                                            const pluginData1 = routePlugin;
                                                                            const id1 = pluginData1.id;
                                                                            pluginData1.enabled = false;
                                                                            await this.patchPluginInAPIGateway(id1, pluginData1);
                                                                        }
                                                                    });
                                                                }
                                                            }
                                                        }
                                                        resp['scopeOfAccess'] = 'public';
                                                        resp['published'] = true;
                                                        const methods1 = [];
                                                        if (resp && resp['methods']) {
                                                            for (const method of resp['methods']) {
                                                                if (method !== 'OPTIONS') {
                                                                    methods1.push(method);
                                                                }
                                                            }
                                                            resp['methods'] = methods1;
                                                        }
                                                        resp['lastModifiedTime'] = Date.now();
                                                        this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                                                            this.platform.updateAPIAuditLog(partner, account, resp['entityname'], resp['version'], 'DAAS', resp, resp);
                                                            this.platform.listOfDataAccessServices = null;
                                                            this.getCategoriesAndEntities();
                                                            this.platform.openSnackBar('API has been published successfully with public access', 'Success', {
                                                                duration: 5000,
                                                                verticalPosition: 'top',
                                                                horizontalPosition: 'center'
                                                            });
                                                        }, updateError => {
                                                            pluginData.enabled = true;
                                                            this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                                                                event.source.checked = !event.source.checked;
                                                                this.platform.handleErrorGracefully(updateError, 'Error while providing public access to your API. Please try again after sometime');
                                                            });
                                                        });
                                                    });
                                                } else {
                                                    this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                                                        this.platform.updateAPIAuditLog(partner, account, resp['entityname'], resp['version'], 'DAAS', resp, resp);
                                                        this.platform.listOfDataAccessServices = null;
                                                        this.getCategoriesAndEntities();
                                                        this.platform.openSnackBar('API has been published successfully with ' + resp['scopeOfAccess'] + ' access', 'Success', {
                                                            duration: 5000,
                                                            verticalPosition: 'top',
                                                            horizontalPosition: 'center'
                                                        });
                                                        resolve('success');
                                                    }, updateError => {
                                                        this.platform.deleteApiWithDependencies(false, false, true, partner, account, localStorage.getItem('partnerKey'), entity, version).then(resp1 => {
                                                            if (event && event !== null) {
                                                                event.source.checked = !event.source.checked;
                                                            }
                                                            this.platform.handleErrorGracefully(updateError, 'Error while publishing your API. Please try again after sometime');
                                                        });
                                                        resolve('failure');
                                                    });
                                                }
                                            });
                                        } else {
                                            //NO PLUGIN
                                            this.configureIPRestrictionAndMakeItPublic(partner, account, entity, version, resp);
                                        }
                                    });
                                    loaderDialog.close();
                                }, updateError => {
                                    this.platform.deleteApiWithDependencies(false, false, true, partner, account, localStorage.getItem('partnerKey'), entity, version).then(resp1 => {
                                        if (event && event !== null) {
                                            event.source.checked = !event.source.checked;
                                        }
                                        this.platform.handleErrorGracefully(updateError, 'Error while publishing your API. Please try again after sometime');
                                    });
                                    loaderDialog.close();
                                    resolve('failure');
                                });
                            }, error => {
                                loaderDialog.close();
                                this.platform.handleErrorGracefully(error, 'Error while publishing your API. Please try again after sometime');
                                // Reverse the toggle to previous state
                                resolve('failure');
                            });
                        } else if (result === 'unpublish') {
                            this.platform.deleteApiWithDependencies(false, false, true, partner, account, localStorage.getItem('partnerKey'), entity, version).then(resp1 => {
                                resp['published'] = false;
                                resp['scopeOfAccess'] = 'private';
                                const methods = [];
                                if (resp && resp['methods']) {
                                    for (const method of resp['methods']) {
                                        if (method !== 'OPTIONS') {
                                            methods.push(method);
                                        }
                                    }
                                    resp['methods'] = methods;
                                }
                                resp['lastModifiedTime'] = Date.now();
                                this.confPost.updateEntity(partner, account, resp).subscribe(updateResp => {
                                    this.platform.updateAPIAuditLog(partner, account, resp['entityname'], resp['version'], 'DAAS', resp, resp);
                                    this.platform.listOfDataAccessServices = null;
                                    this.getCategoriesAndEntities();
                                    this.platform.openSnackBar('API has been unpublished successfully.', 'Success', {
                                        duration: 5000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                }, updateError => {
                                    this.kong.configureApiGatewayWithIpRestrictionWithMethods(partner, account, entity, version, resp['scopeOfAccess'] !== 'public', false, resp['methods'], logTimeStamp, '').then(resp1 => {
                                        if (event && event !== null) {
                                            event.source.checked = !event.source.checked;
                                        }
                                        this.platform.handleErrorGracefully(updateError, 'Error while unpublishing your API. Please try again after sometime');
                                    });
                                });
                            }, error => {
                                if (event && event !== null) {
                                    event.source.checked = !event.source.checked;
                                }
                                this.platform.handleErrorGracefully(error, 'Error while unpublishing your API. Please try again after sometime');
                            });
                        } else {
                            if (event && event !== null) {
                                event.source.checked = !event.source.checked;
                            }
                        }
                    });
                }
            }, error => {
                if (event && event !== null) {
                    event.source.checked = !event.source.checked;
                }
                entityLoader.close();
                this.platform.handleErrorGracefully(error, 'Error while retrieving your API. Please try again after sometime');
            });
        });
    }

    openMetricsDialog(partner, account, entity, version) {
        const dialogRef = this.dialog.open(DatadogMetricsComponent, {
            width: '465px',
            height: '650px',
            data: {
                partner: partner,
                account: account,
                APIName: entity,
                version: version
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'redirect') {
                this.router.navigateByUrl('api?partner=' + partner + '&account=' + account + '&entity=' + entity + '&version=' + version);
            }
        });
    }

    // openMetricsDialog(partner, account, entity, version): void {
    //     const data = {};
    //     data['partner'] = partner;
    //     data['account'] = account;
    //     data['entity'] = entity;
    //     data['version'] = version;
    //     data['url'] = this.url;
    //     data['partnerKey'] = this.partnerKey;
    //     const dialogRef = this.dialog.open(MetricsComponent, {
    //         width: '80%',
    //         data: data
    //     });
    //
    //     dialogRef.afterClosed().subscribe(result => {
    //     });
    // }

    getMaxCount() {
        if (this.platform.maxCount !== null && this.platform.maxCount !== undefined) {
            this.maxCount = this.platform.maxCount;
        } else {
            this.confPost.getMaxAPILimit(localStorage.getItem('partner')).subscribe(count => {
                this.maxCount = count;
                this.platform.maxCount = count;
            });
        }
    }

    refreshBillingForPartnerAccount() {
        this.confPost.refreshBillingForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            this.platform.openSnackBar('Refreshed the duration of API Availability for this account successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while refreshing the duration of API Availability', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getStorageDetails() {
        // if (this.metrics === null || this.metrics === undefined || this.metrics === '') {
        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            if (data) {
                this.metrics = data[0];
            }
        });
        // }
    }

    public getCategoriesAndEntities = async () => {
        if (this.platform.listOfDataAccessServices === null || this.platform.listOfDataAccessServices === undefined) {
            // this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
            //     this.platform.listOfDataAccessServices = response;
            //     this.items = this.platform.listOfDataAccessServices;
            //     this.metrics['noOfApis'] = this.items.length;
            //     this.item = [];
            //     this.platform.listOfDataAccessServices.forEach((entity) => {
            //         if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + this.account + '=>' + entity['entityname'] + '=>' + entity['version'])) {
            //             this.item.push(entity);
            //         }
            //     });
            //     this.countOfDataAccessServices = this.item.length;
            //     this.platform.countOfDataAccessServices = this.countOfDataAccessServices;
            // });


            this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                this.platform.listOfDataAccessServices = data;
                this.item = [];
                // if (this.metrics || this.metrics['noOfApis'] > 0) {
                //     if (this.platform.countOfDataAccessServices !== 0) {
                //         this.countOfDataAccessServices = this.platform.countOfDataAccessServices;
                //     } else {
                //         this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(entityCount => {
                //                 if (entityCount) {
                //                     this.countOfDataAccessServices = entityCount['noOfApis'];
                //                 } else {
                //                     this.countOfDataAccessServices = 0;
                //                 }
                //                 this.platform.countOfDataAccessServices = this.countOfDataAccessServices;
                //             },
                //             error => {
                //                 this.platform.openSnackBar('Error while getting data access services count for partner: ' + error.error.message, 'Error', {
                //                     duration: 15000,
                //                     verticalPosition: 'top',
                //                     horizontalPosition: 'center'
                //                 });
                //             });
                //     }
                // }

                // this.items = this.platform.listOfDataAccessServices[0]['accounts'];
                // this.metrics = this.platform.listOfDataAccessServices[0];
                // this.platform.listOfDataAccessServices[0]['accounts'].forEach((account) => {
                //     account.categories.forEach((category) => {
                //         category.entities.forEach((entity) => {
                //             const ent = {};
                //             ent['category'] = category.category;
                //             ent['account_id'] = account.account_id;
                //             ent['APIs'] = entity;
                //             if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + ent['account_id'] + '=>' + this.getValue(ent['APIs']) + '=>' + this.getVersion(ent['APIs']))) {
                //                 this.item.push(ent);
                //             }
                //         });
                //     });
                // });

                this.items = this.platform.listOfDataAccessServices;
                this.metrics['noOfApis'] = this.platform.listOfDataAccessServices.length;
                this.item = [];
                this.platform.listOfDataAccessServices.forEach((ent) => {
                    if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + this.account + '=>' + ent['entityname'] + '=>' + ent['version'])) {
                        this.item.push(ent);
                    }
                });
                this.calculateCountOfAPIs();
                this.countOfDataAccessServices = this.item.length;
                this.platform.countOfDataAccessServices = this.countOfDataAccessServices;
            });
        } else {
            this.items = this.platform.listOfDataAccessServices;
            this.metrics['noOfApis'] = this.platform.listOfDataAccessServices.length;
            this.item = [];
            // if (this.metrics || this.metrics['noOfApis'] > 0) {
            //     if (this.platform.countOfDataAccessServices !== 0) {
            //         this.countOfDataAccessServices = this.platform.countOfDataAccessServices;
            //     } else {
            //         this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(entityCount => {
            //                 if (entityCount) {
            //                     this.countOfDataAccessServices = entityCount['noOfApis'];
            //                 } else {
            //                     this.countOfDataAccessServices = 0;
            //                 }
            //                 this.platform.countOfDataAccessServices = this.countOfDataAccessServices;
            //             },
            //             error => {
            //                 this.platform.openSnackBar('Error while getting data access services count for partner: ' + error.error.message, 'Error', {
            //                     duration: 15000,
            //                     verticalPosition: 'top',
            //                     horizontalPosition: 'center'
            //                 });
            //             });
            //     }
            // }


            // this.platform.listOfDataAccessServices[0]['accounts'].forEach((account) => {
            //     account.categories.forEach((category) => {
            //         category.entities.forEach((entity) => {
            //             const ent = {};
            //             ent['category'] = category.category;
            //             ent['account_id'] = account.account_id;
            //             ent['APIs'] = entity;
            //             if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + ent['account_id'] + '=>' + this.getValue(ent['APIs']) + '=>' + this.getVersion(ent['APIs']))) {
            //                 this.item.push(ent);
            //             }
            //         });
            //     });
            // });

            this.platform.listOfDataAccessServices.forEach((ent) => {
                if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + this.account + '=>' + ent['entityname'] + '=>' + ent['version'])) {
                    this.item.push(ent);
                }
            });
            this.calculateCountOfAPIs();
            this.countOfDataAccessServices = this.item.length;
            this.platform.countOfDataAccessServices = this.countOfDataAccessServices;
        }
    };

    public getApiExecutorsByPartnerAccountType = async () => {

        return new Promise((resolve, reject) => {
            if (this.platform.apiExecutors !== null && this.platform.apiExecutors !== undefined && this.platform.apiExecutors.length > 0) {
                this.apiExecutors = this.platform.apiExecutors;
                this.countOfApiExecutors = this.platform.countOfApiExecutors;
                // localStorage.setItem('dataAccessAPI', JSON.stringify(this.apiExecutors));
                this.platform.dataAccessAPI = JSON.stringify(this.apiExecutors);

                this.executors = this.platform.businessLogicExecutors;
                if (this.executors) {
                    this.countOfBusinessLogicApis = this.platform.businessLogicExecutors.length;
                    this.platform.countOfBusinessLogicApis = this.platform.businessLogicExecutors.length;
                }
                // if (this.countOfBusinessLogicApis > 0) {
                //     this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                // }
                // this.calculateCountOfAPIs();
                // localStorage.setItem('businessLogicAPI', JSON.stringify(this.executors));
                this.platform.businessLogicAPI = JSON.stringify(this.executors);

                this.thirdPartyApiExecutors = this.platform.thirdPartyApiExecutors;
                // this.calculateCountOfAPIs();
                // localStorage.setItem('thirdPartyAPI', JSON.stringify(this.thirdPartyApiExecutors));
                this.platform.thirdPartyAPI = JSON.stringify(this.thirdPartyApiExecutors);
                if (this.thirdPartyApiExecutors) {
                    this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
                    this.platform.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
                }
                // if (this.countOfThirdPartyApis > 0) {
                //     this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                // }

                this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
                this.unifiedQueryExecutors = this.platform.unifiedQueryExecutors;
                // this.calculateCountOfAPIs();
                // localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
                this.platform.sqlQueryAPI = JSON.stringify(this.sqlQueryExecutors);
                this.platform.unifiedQueryAPI = JSON.stringify(this.unifiedQueryExecutors);
                if (this.sqlQueryExecutors) {
                    this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
                    this.platform.countOfSqlQueryApis = this.sqlQueryExecutors.length;
                }
                if (this.unifiedQueryExecutors) {
                    this.countOfUnifiedQueryApis = this.unifiedQueryExecutors.length;
                    this.platform.countOfUnifiedQueryApis = this.unifiedQueryExecutors.length;
                }

                this.testSuiteExecutors = this.platform.testSuiteExecutors;
                // this.calculateCountOfAPIs();
                // localStorage.setItem('testSuiteAPI', JSON.stringify(this.testSuiteExecutors));
                this.platform.testSuiteAPI = JSON.stringify(this.testSuiteExecutors);
                if (this.testSuiteExecutors) {
                    this.countOfTestSuiteApis = this.testSuiteExecutors.length;
                    this.platform.countOfTestSuiteApis = this.testSuiteExecutors.length;
                }

                this.workFlowExecutors = this.platform.workFlowExecutors;
                // this.calculateCountOfAPIs();
                // localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
                this.platform.workFlowAPI = JSON.stringify(this.workFlowExecutors);
                if (this.workFlowExecutors) {
                    this.countOfWorkflowApis = this.workFlowExecutors.length;
                    this.platform.countOfWorkflowApis = this.workFlowExecutors.length;
                }

                this.plSqlExecutors = this.platform.plsqlExecutors;
                // this.calculateCountOfAPIs();
                // localStorage.setItem('plSqlApis', JSON.stringify(this.plSqlExecutors));
                if (this.plSqlExecutors) {
                    this.countOfPlSqlApis = this.platform.countOfPlSqlApis;
                    this.platform.plSqlAPI = JSON.stringify(this.plSqlExecutors);
                }

                this.dataTransformationExecutors = this.platform.dataTransformationExecutors;
                // this.calculateCountOfAPIs();
                // localStorage.setItem('plSqlApis', JSON.stringify(this.plSqlExecutors));
                if (this.dataTransformationExecutors) {
                    this.countOfDataTransformationApis = this.platform.countOfDataTransformationApis;
                }

                this.dmnExecutors = this.platform.dmnExecutors;
                // this.calculateCountOfAPIs();
                // localStorage.setItem('dmnAPI', JSON.stringify(this.dmnExecutors));
                this.platform.dmnAPI = JSON.stringify(this.dmnExecutors);
                if (this.dmnExecutors) {
                    this.countOfDmnApis = this.dmnExecutors.length;
                    this.platform.countOfDmnApis = this.dmnExecutors.length;
                }

                this.calculateCountOfAPIs();
                resolve('success');
            } else {
                this.platform.getExecutorsForPartnerAccount().then(resp => {
                    this.apiExecutors = this.platform.apiExecutors;
                    this.countOfApiExecutors = this.platform.countOfApiExecutors;
                    // localStorage.setItem('dataAccessAPI', JSON.stringify(this.apiExecutors));
                    this.platform.dataAccessAPI = JSON.stringify(this.apiExecutors);

                    this.executors = this.platform.businessLogicExecutors;
                    if (this.executors) {
                        this.countOfBusinessLogicApis = this.platform.businessLogicExecutors.length;
                        this.platform.countOfBusinessLogicApis = this.platform.businessLogicExecutors.length;
                    }
                    // if (this.countOfBusinessLogicApis > 0) {
                    //     this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                    // }
                    // this.calculateCountOfAPIs();
                    // localStorage.setItem('businessLogicAPI', JSON.stringify(this.executors));
                    this.platform.businessLogicAPI = JSON.stringify(this.executors);

                    this.thirdPartyApiExecutors = this.platform.thirdPartyApiExecutors;
                    // this.calculateCountOfAPIs();
                    // localStorage.setItem('thirdPartyAPI', JSON.stringify(this.thirdPartyApiExecutors));
                    this.platform.thirdPartyAPI = JSON.stringify(this.thirdPartyApiExecutors);
                    if (this.thirdPartyApiExecutors) {
                        this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
                        this.platform.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
                    }
                    // if (this.countOfThirdPartyApis > 0) {
                    //     this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                    // }
                    this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
                    this.unifiedQueryExecutors = this.platform.unifiedQueryExecutors;
                    // this.calculateCountOfAPIs();
                    // localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
                    this.platform.sqlQueryAPI = JSON.stringify(this.sqlQueryExecutors);
                    this.platform.unifiedQueryAPI = JSON.stringify(this.unifiedQueryExecutors);
                    if (this.sqlQueryExecutors) {
                        this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
                        this.platform.countOfSqlQueryApis = this.sqlQueryExecutors.length;
                    }
                    if (this.unifiedQueryExecutors) {
                        this.countOfUnifiedQueryApis = this.unifiedQueryExecutors.length;
                        this.platform.countOfUnifiedQueryApis = this.unifiedQueryExecutors.length;
                    }

                    this.testSuiteExecutors = this.platform.testSuiteExecutors;
                    // this.calculateCountOfAPIs();
                    // localStorage.setItem('testSuiteAPI', JSON.stringify(this.testSuiteExecutors));
                    this.platform.testSuiteAPI = JSON.stringify(this.testSuiteExecutors);
                    if (this.testSuiteExecutors) {
                        this.countOfTestSuiteApis = this.testSuiteExecutors.length;
                        this.platform.countOfTestSuiteApis = this.testSuiteExecutors.length;
                    }

                    this.workFlowExecutors = this.platform.workFlowExecutors;
                    // this.calculateCountOfAPIs();
                    // localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
                    this.platform.workFlowAPI = JSON.stringify(this.workFlowExecutors);
                    if (this.workFlowExecutors) {
                        this.countOfWorkflowApis = this.workFlowExecutors.length;
                        this.platform.countOfWorkflowApis = this.workFlowExecutors.length;
                    }

                    this.plSqlExecutors = this.platform.plsqlExecutors;
                    // this.calculateCountOfAPIs();
                    // localStorage.setItem('plSqlApis', JSON.stringify(this.plSqlExecutors));
                    if (this.plSqlExecutors) {
                        this.countOfPlSqlApis = this.platform.countOfPlSqlApis;
                        this.platform.plSqlAPI = JSON.stringify(this.plSqlExecutors);
                    }

                    this.dataTransformationExecutors = this.platform.dataTransformationExecutors;
                    // this.calculateCountOfAPIs();
                    // localStorage.setItem('plSqlApis', JSON.stringify(this.plSqlExecutors));
                    if (this.dataTransformationExecutors) {
                        this.countOfDataTransformationApis = this.platform.countOfDataTransformationApis;
                    }

                    this.dmnExecutors = this.platform.dmnExecutors;
                    // this.calculateCountOfAPIs();
                    // localStorage.setItem('dmnAPI', JSON.stringify(this.dmnExecutors));
                    this.platform.dmnAPI = JSON.stringify(this.dmnExecutors);
                    if (this.dmnExecutors) {
                        this.countOfDmnApis = this.dmnExecutors.length;
                        this.platform.countOfDmnApis = this.dmnExecutors.length;
                    }

                    this.calculateCountOfAPIs();
                    resolve('success');
                }, error => {
                    resolve('failed');
                });

                // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'API').subscribe(data => {
                //     this.apiExecutors = [];
                //     let resp: any;
                //     resp = data;
                //     for (const item of resp) {
                //         if (item) {
                //             if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_category + '=>' + item.executor_version)) {
                //                 this.apiExecutors.push(item);
                //             }
                //         }
                //     }
                //     this.platform.apiExecutors = this.apiExecutors;
                //     if (this.apiExecutors) {
                //         this.countOfApiExecutors = this.apiExecutors.length;
                //         this.platform.countOfApiExecutors = this.apiExecutors.length;
                //     }
                //
                //     this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                //
                //     localStorage.setItem('dataAccessAPI', JSON.stringify(this.apiExecutors));
                //     this.platform.dataAccessAPI = JSON.stringify(this.apiExecutors);
                // }, error => {
                //     this.platform.openSnackBar('Error while getting API Executors grouped by Type for a partner account: ' + error.error.message, 'Error', {
                //         duration: 30000,
                //         verticalPosition: 'top',
                //         horizontalPosition: 'center'
                //     });
                // });
            }
        });
    };

    getBusinessLogicApiExecutorsByPartnerAccountType() {
        if (this.platform.executors !== null && this.platform.executors !== undefined && this.platform.executors.length > 0) {
            this.executors = this.platform.executors;
            this.calculateCountOfAPIs();
            this.countOfBusinessLogicApis = this.platform.countOfBusinessLogicApis;
            // localStorage.setItem('businessLogicAPI', JSON.stringify(this.executors));
            this.platform.businessLogicAPI = JSON.stringify(this.executors);
        } else {
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.executors = this.platform.businessLogicExecutors;
                if (this.executors) {
                    this.countOfBusinessLogicApis = this.platform.businessLogicExecutors.length;
                    this.platform.countOfBusinessLogicApis = this.platform.businessLogicExecutors.length;
                }
                if (this.countOfBusinessLogicApis > 0) {
                    this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                }
                this.calculateCountOfAPIs();
                // localStorage.setItem('businessLogicAPI', JSON.stringify(this.executors));
                this.platform.businessLogicAPI = JSON.stringify(this.executors);
            });

            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'BUSINESSLOGIC').subscribe(data => {
            //     this.executors = [];
            //     let resp: any;
            //     resp = data;
            //     for (const item of resp) {
            //         if (item) {
            //             if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
            //                 this.executors.push(item);
            //             }
            //         }
            //     }
            //     this.platform.businessLogicExecutors = this.executors;
            //     if (this.executors) {
            //         this.countOfBusinessLogicApis = this.platform.businessLogicExecutors.length;
            //         this.platform.countOfBusinessLogicApis = this.platform.businessLogicExecutors.length;
            //     }
            //     if (this.countOfBusinessLogicApis > 0) {
            //         this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
            //     }
            //     this.calculateCountOfAPIs();
            //     localStorage.setItem('businessLogicAPI', JSON.stringify(this.executors));
            //     this.platform.businessLogicAPI = JSON.stringify(this.executors);
            // }, error => {
            //     this.platform.openSnackBar('Error while getting Business Logic APIs grouped by Type for a partner account: ' + error.error.message, 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
            // this.executors = this.platform.businessLogicExecutors;
            // this.countOfBusinessLogicApis = this.platform.countOfBusinessLogicApis;
        }

        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'BUSINESSLOGIC').subscribe(data => {
        //     this.executors = data;
        //     if (this.executors) {
        //         this.countOfBusinessLogicApis = this.executors.length;
        //     }
        //     localStorage.setItem('businessLogicAPI', JSON.stringify(this.executors));
        // });
    }

    getThirdPartyApiExecutorsByPartnerAccountType() {
        if (this.platform.thirdPartyApiExecutors !== null && this.platform.thirdPartyApiExecutors !== undefined && this.platform.thirdPartyApiExecutors.length > 0) {
            this.thirdPartyApiExecutors = this.platform.thirdPartyApiExecutors;
            this.countOfThirdPartyApis = this.platform.countOfThirdPartyApis;
            this.platform.thirdPartyApiExecutors = this.thirdPartyApiExecutors;
            this.calculateCountOfAPIs();
            // localStorage.setItem('thirdPartyAPI', JSON.stringify(this.thirdPartyApiExecutors));
        } else {
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.thirdPartyApiExecutors = this.platform.thirdPartyApiExecutors;
                this.calculateCountOfAPIs();
                // localStorage.setItem('thirdPartyAPI', JSON.stringify(this.thirdPartyApiExecutors));
                this.platform.thirdPartyAPI = JSON.stringify(this.thirdPartyApiExecutors);
                if (this.thirdPartyApiExecutors) {
                    this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
                    this.platform.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
                }
                if (this.countOfThirdPartyApis > 0) {
                    this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                }
            });

            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'THIRDPARTY').subscribe(data => {
            //     this.thirdPartyApiExecutors = [];
            //     let resp: any;
            //     resp = data;
            //     for (const item of resp) {
            //         if (item) {
            //             if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
            //                 this.thirdPartyApiExecutors.push(item);
            //             }
            //         }
            //     }
            //     this.platform.thirdPartyApiExecutors = this.thirdPartyApiExecutors;
            //     this.calculateCountOfAPIs();
            //     localStorage.setItem('thirdPartyAPI', JSON.stringify(this.thirdPartyApiExecutors));
            //     this.platform.thirdPartyAPI = JSON.stringify(this.thirdPartyApiExecutors);
            //     if (this.thirdPartyApiExecutors) {
            //         this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
            //         this.platform.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
            //     }
            //     if (this.countOfThirdPartyApis > 0) {
            //         this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
            //     }
            // }, error => {
            //     this.platform.openSnackBar('Error while getting Third Party APIs grouped by Type for a partner account: ' + error.error.message, 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
            // this.thirdPartyApiExecutors = this.platform.thirdPartyApiExecutors;
            // this.countOfThirdPartyApis = this.countOfThirdPartyApis
        }

        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'THIRDPARTY').subscribe(data => {
        //     this.thirdPartyApiExecutors = data;
        //     localStorage.setItem('thirdPartyAPI', JSON.stringify(this.thirdPartyApiExecutors));
        //     if (this.thirdPartyApiExecutors) {
        //         this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
        //     }
        // });
    }

    getApplicationsByPartnerAccount() {
        if (this.platform.applicationData !== null && this.platform.applicationData !== undefined && this.platform.applicationData.length > 0) {
            this.countOfApplications = this.platform.countOfApplications;
            this.applicationData = this.platform.applicationData;
        } else {
            this.platform.getApplicationsForPartnerAccount().then(resp => {
                this.countOfApplications = this.platform.countOfApplications;
                this.applicationData = this.platform.applicationData;
            });
        }
    }

    getSqlQueryApiExecutorsByPartnerAccountType() {
        if (this.platform.sqlQueryExecutors !== null && this.platform.sqlQueryExecutors !== undefined && this.platform.thirdPartyApiExecutors.length > 0) {
            this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
            this.countOfSqlQueryApis = this.platform.countOfSqlQueryApis;
            this.calculateCountOfAPIs();
            // localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
            this.platform.sqlQueryAPI = JSON.stringify(this.sqlQueryExecutors);
        } else {
            // this.platform.getSqlQueryApiExecutorsByPartnerAccountType();
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
                this.calculateCountOfAPIs();
                // localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
                this.platform.sqlQueryAPI = JSON.stringify(this.sqlQueryExecutors);
                if (this.sqlQueryExecutors) {
                    this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
                    this.platform.countOfSqlQueryApis = this.sqlQueryExecutors.length;
                }
                if (this.countOfSqlQueryApis > 0) {
                    this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                }
            });

            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'SQLQUERY').subscribe(data => {
            //     this.sqlQueryExecutors = [];
            //     let resp: any;
            //     resp = data;
            //     for (const item of resp) {
            //         if (item) {
            //             if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
            //                 this.sqlQueryExecutors.push(item);
            //             }
            //         }
            //     }
            //     this.platform.sqlQueryExecutors = this.sqlQueryExecutors;
            //     this.calculateCountOfAPIs();
            //     localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
            //     this.platform.sqlQueryAPI = JSON.stringify(this.sqlQueryExecutors);
            //     if (this.sqlQueryExecutors) {
            //         this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
            //         this.platform.countOfSqlQueryApis = this.sqlQueryExecutors.length;
            //     }
            //     if (this.countOfSqlQueryApis > 0) {
            //         this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
            //     }
            // }, error => {
            //     this.platform.openSnackBar('Error while getting SQL Query APIs grouped by Type for a partner account: ' + error.error.message, 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
            // this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
            // this.countOfSqlQueryApis = this.platform.countOfSqlQueryApis;
        }
        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'SQLQUERY').subscribe(data => {
        //     this.sqlQueryExecutors = data;
        //     localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
        //     if (this.sqlQueryExecutors) {
        //         this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
        //     }
        // });
    }

    getTestSuiteApiExecutorsByPartnerAccountType() {
        if (this.platform.testSuiteExecutors !== null && this.platform.testSuiteExecutors !== undefined && this.platform.testSuiteExecutors.length > 0) {
            this.testSuiteExecutors = this.platform.testSuiteExecutors;
            this.countOfTestSuiteApis = this.platform.countOfTestSuiteApis;
            this.calculateCountOfAPIs();
            // localStorage.setItem('testSuiteAPI', JSON.stringify(this.testSuiteExecutors));
            this.platform.testSuiteAPI = JSON.stringify(this.testSuiteExecutors);
        } else {
            // this.platform.getSqlQueryApiExecutorsByPartnerAccountType();
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.testSuiteExecutors = this.platform.testSuiteExecutors;
                this.calculateCountOfAPIs();
                // localStorage.setItem('testSuiteAPI', JSON.stringify(this.testSuiteExecutors));
                this.platform.testSuiteAPI = JSON.stringify(this.testSuiteExecutors);
                if (this.testSuiteExecutors) {
                    this.countOfTestSuiteApis = this.testSuiteExecutors.length;
                    this.platform.countOfTestSuiteApis = this.testSuiteExecutors.length;
                }
                if (this.countOfTestSuiteApis > 0) {
                    this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                }
            });

            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'TESTSUITE').subscribe(data => {
            //     this.testSuiteExecutors = [];
            //     let resp: any;
            //     resp = data;
            //     for (const item of resp) {
            //         if (item) {
            //             if (this.platform.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
            //                 this.testSuiteExecutors.push(item);
            //             }
            //         }
            //     }
            //     this.platform.testSuiteExecutors = this.testSuiteExecutors;
            //     this.calculateCountOfAPIs();
            //     localStorage.setItem('testSuiteAPI', JSON.stringify(this.testSuiteExecutors));
            //     this.platform.testSuiteAPI = JSON.stringify(this.testSuiteExecutors);
            //     if (this.testSuiteExecutors) {
            //         this.countOfTestSuiteApis = this.testSuiteExecutors.length;
            //         this.platform.countOfTestSuiteApis = this.testSuiteExecutors.length;
            //     }
            //     if (this.countOfTestSuiteApis > 0) {
            //         this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
            //     }
            // }, error => {
            //     this.platform.openSnackBar('Error while getting Test Suite APIs grouped by Type for a partner account: ' + error.error.message, 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
            // this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
            // this.countOfSqlQueryApis = this.platform.countOfSqlQueryApis;
        }
    }

    getPLSQLApiExecutorsByPartnerAccountType() {
        if (this.platform.plsqlExecutors !== null && this.platform.plsqlExecutors !== undefined && this.platform.plsqlExecutors.length > 0) {
            this.plSqlExecutors = this.platform.plsqlExecutors;
            this.countOfPlSqlApis = this.platform.countOfPlSqlApis;
            this.calculateCountOfAPIs();
            // localStorage.setItem('plSqlApis', JSON.stringify(this.plSqlExecutors));
            this.platform.plSqlAPI = JSON.stringify(this.plSqlExecutors);
        } else {
            // this.platform.getSqlQueryApiExecutorsByPartnerAccountType();
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.plSqlExecutors = this.platform.plsqlExecutors;
                this.calculateCountOfAPIs();
                // localStorage.setItem('plSqlApis', JSON.stringify(this.plSqlExecutors));
                this.platform.plSqlAPI = JSON.stringify(this.plSqlExecutors);
                if (this.plSqlExecutors) {
                    this.countOfPlSqlApis = this.plSqlExecutors.length;
                    this.platform.countOfPlSqlApis = this.plSqlExecutors.length;
                }
                if (this.countOfPlSqlApis > 0) {
                    this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                }
            });
            // this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
            // this.countOfSqlQueryApis = this.platform.countOfSqlQueryApis;
        }
    }

    getDataTransformationApiExecutorsByPartnerAccountType() {
        if (this.platform.dataTransformationExecutors !== null && this.platform.dataTransformationExecutors !== undefined && this.platform.dataTransformationExecutors.length > 0) {
            this.dataTransformationExecutors = this.platform.dataTransformationExecutors;
            this.countOfDataTransformationApis = this.platform.countOfDataTransformationApis;
            this.calculateCountOfAPIs();
            // localStorage.setItem('plSqlApis', JSON.stringify(this.plSqlExecutors));
            // this.platform.plSqlAPI = JSON.stringify(this.plSqlExecutors);
        } else {
            // this.platform.getSqlQueryApiExecutorsByPartnerAccountType();
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.dataTransformationExecutors = this.platform.dataTransformationExecutors;
                this.calculateCountOfAPIs();
                // localStorage.setItem('plSqlApis', JSON.stringify(this.plSqlExecutors));
                // this.platform.plSqlAPI = JSON.stringify(this.plSqlExecutors);
                if (this.dataTransformationExecutors) {
                    this.countOfDataTransformationApis = this.dataTransformationExecutors.length;
                    this.platform.countOfDataTransformationApis = this.dataTransformationExecutors.length;
                }
                if (this.countOfPlSqlApis > 0) {
                    this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());
                }
            });
            // this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
            // this.countOfSqlQueryApis = this.platform.countOfSqlQueryApis;
        }
    }

    getWorkFlowApiExecutorsByPartnerAccountType() {
        if (this.platform.workFlowExecutors !== null && this.platform.workFlowExecutors !== undefined && this.platform.workFlowExecutors.length > 0) {
            this.workFlowExecutors = this.platform.workFlowExecutors;
            this.countOfWorkflowApis = this.platform.countOfWorkflowApis;
            this.calculateCountOfAPIs();
            // localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
            this.platform.workFlowAPI = JSON.stringify(this.workFlowExecutors);
        } else {
            // this.platform.getWorkFlowApiExecutorsByPartnerAccountType();
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.workFlowExecutors = this.platform.workFlowExecutors;
                this.calculateCountOfAPIs();
                // localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
                this.platform.workFlowAPI = JSON.stringify(this.workFlowExecutors);
                if (this.workFlowExecutors) {
                    this.countOfWorkflowApis = this.workFlowExecutors.length;
                    this.platform.countOfWorkflowApis = this.workFlowExecutors.length;
                }
            });
            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'WORKFLOW').subscribe(data => {
            //     this.workFlowExecutors = data;
            //     this.platform.workFlowExecutors = data;
            //     this.calculateCountOfAPIs();
            //     localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
            //     this.platform.workFlowAPI = JSON.stringify(this.workFlowExecutors);
            //     if (this.workFlowExecutors) {
            //         this.countOfWorkflowApis = this.workFlowExecutors.length;
            //         this.platform.countOfWorkflowApis = this.workFlowExecutors.length;
            //     }
            // }, error => {
            //     this.platform.openSnackBar('Error while getting Workflow APIs grouped by Type for a partner account: ' + error.error.message, 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
            // this.workFlowExecutors = this.platform.workFlowExecutors;
            // this.countOfWorkflowApis = this.platform.countOfWorkflowApis;
        }

        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'WORKFLOW').subscribe(data => {
        //     this.workFlowExecutors = data;
        //     localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
        //     if (this.workFlowExecutors) {
        //         this.countOfWorkflowApis = this.workFlowExecutors.length;
        //     }
        // });
    }

    getDMNApiExecutorsByPartnerAccountType() {
        if (this.platform.dmnExecutors !== null && this.platform.dmnExecutors !== undefined && this.platform.dmnExecutors.length > 0) {
            this.dmnExecutors = this.platform.dmnExecutors;
            this.countOfDmnApis = this.platform.countOfDmnApis;
            this.calculateCountOfAPIs();
            // localStorage.setItem('dmnAPI', JSON.stringify(this.dmnExecutors));
            this.platform.dmnAPI = JSON.stringify(this.dmnExecutors);
        } else {
            // this.platform.getDMNApiExecutorsByPartnerAccountType();
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.dmnExecutors = this.platform.dmnExecutors;
                this.calculateCountOfAPIs();
                // localStorage.setItem('dmnAPI', JSON.stringify(this.dmnExecutors));
                this.platform.dmnAPI = JSON.stringify(this.dmnExecutors);
                if (this.dmnExecutors) {
                    this.countOfDmnApis = this.dmnExecutors.length;
                    this.platform.countOfDmnApis = this.dmnExecutors.length;
                }
            });
            // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'DECISION').subscribe(data => {
            //     this.dmnExecutors = data;
            //     this.platform.dmnExecutors = data;
            //     this.calculateCountOfAPIs();
            //     localStorage.setItem('dmnAPI', JSON.stringify(this.dmnExecutors));
            //     this.platform.dmnAPI = JSON.stringify(this.dmnExecutors);
            //     if (this.dmnExecutors) {
            //         this.countOfDmnApis = this.dmnExecutors.length;
            //         this.platform.countOfDmnApis = this.dmnExecutors.length;
            //     }
            // }, error => {
            //     this.platform.openSnackBar('Error while getting DMN APIs grouped by Type for a partner account: ' + error.error.message, 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
            // this.dmnExecutors = this.platform.dmnExecutors;
            // this.countOfDmnApis = this.platform.countOfDmnApis;
        }

        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'DECISION').subscribe(data => {
        //     this.dmnExecutors = data;
        //     localStorage.setItem('dmnAPI', JSON.stringify(this.dmnExecutors));
        //     if (this.dmnExecutors) {
        //         this.countOfDmnApis = this.dmnExecutors.length;
        //     }
        // });
    }

    // getb2bAPIs() {
    //     if (this.platform.b2bExecutors !== null && this.platform.b2bExecutors !== undefined && this.platform.b2bExecutors.length > 0) {
    //         this.b2bArray = this.platform.b2bExecutors;
    //     } else {
    //         // this.platform.getb2bAPIs();
    //         this.confPost.getApiExecutorsForThirdPartnerAccount('b2b', 'b2b')
    //             .toPromise().then(data1 => {
    //             this.b2bArray = data1;
    //             this.platform.completeb2bExecutors = data1;
    //             const b2bArrayValues = [];
    //             for (let i = 0; i < this.b2bArray.length; i++) {
    //                 for (let j = 0; j < this.b2bArray[i]['executors'].length; j++) {
    //                     b2bArrayValues.push('B2b_' + this.b2bArray[i]['executors'][j]['executor_category_group'] + '_' + this.b2bArray[i]['executors'][j]['executor_name'] + '_' + this.b2bArray[i]['executors'][j]['executor_version']);
    //                 }
    //             }
    //             localStorage.setItem('b2bAPI', JSON.stringify(b2bArrayValues));
    //             this.platform.b2bAPI = JSON.stringify(b2bArrayValues);
    //         }, error => {
    //             this.platform.openSnackBar('Error while getting DMN APIs grouped by Type for a partner account: ' + error.error.message, 'Error', {
    //                 duration: 30000,
    //                 verticalPosition: 'top',
    //                 horizontalPosition: 'center'
    //             });
    //         });
    //         // this.b2bArray = this.platform.b2bExecutors;
    //     }
    // }

    getEntityCountForPartner() {
        if (this.platform.countPartnerEntities !== null && this.platform.countPartnerEntities !== undefined) {
            this.countPartnerEntities = this.platform.countPartnerEntities;
        } else {
            // this.platform.getEntityCountForPartner();
            this.confPost.getEntityCountForPartner(localStorage.getItem('partner')).subscribe(data => {
                    this.countPartnerEntities = data;
                    this.platform.countPartnerEntities = data;
                },
                error => {
                    this.platform.openSnackBar('Error while getting count of entities for partner: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            // this.countPartnerEntities = this.platform.countPartnerEntities;
        }
        //Need to check on this
        if (this.countPartnerEntities === null || this.countPartnerEntities === 0) {
            this.confPost.getEntityCountForPartner(localStorage.getItem('partner')).subscribe(data => {
                this.countPartnerEntities = data;
                this.countEnable = true;
            });
        }
    }

    getEntityCountForPartnerAccount() {
        if (this.platform.countPartnerAccountEntities !== null && this.platform.countPartnerAccountEntities !== undefined) {
            this.countPartnerAccountEntities = this.platform.countPartnerAccountEntities;
        } else {
            // this.platform.getEntityCountForPartnerAccount();
            this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                    this.countPartnerAccountEntities = data;
                    this.platform.countPartnerAccountEntities = data;
                },
                error => {
                    this.platform.openSnackBar('Error while getting count of entities for partner account: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            // this.countPartnerAccountEntities = this.platform.countPartnerAccountEntities;
        }
        // if (this.countPartnerAccountEntities === null || this.countPartnerAccountEntities === 0) {
        //     this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //         this.countPartnerAccountEntities = data;
        //     });
        // }
    }

    getApiExecutorsByPartnerAccount() {
        this.confPost.getApiExecutorsByPartnerAccount(this.partner, this.account, 'partner=' + this.partner + '&account=' + this.account + '&fields=executor_name,executor_version,executor_method_type,executor_type,executor_scope,executor_display_name,executor_category,service_provider,apiUrl,published,scopeOfAccess,registeredAsIs,creationTime,lastModifiedTime,executor_description').subscribe(data => {
            this.executors = data;
        });
    }

    // getCloudWatchLatencyMetrics() {
    //     if (this.platform.cloudWatchLatency !== null && this.platform.cloudWatchLatency !== undefined) {
    //         this.cloudWatchLatency = this.platform.cloudWatchLatency;
    //         if (this.cloudWatchLatency !== null && this.cloudWatchLatency !== undefined) {
    //             const value = [];
    //             const label = [];
    //             for (let t = 0; t < this.cloudWatchLatency.length; t++) {
    //                 value.push(parseInt(this.cloudWatchLatency[t]['y']));
    //                 label.push(this.cloudWatchLatency[t]['label']);
    //             }
    //             this.barChartDataLatency[0].data = value;
    //             this.barChartLabelsLatency = label;
    //
    //             let latencyChart = new CanvasJS.Chart('chartContainer', {
    //                 animationEnabled: true,
    //                 exportEnabled: false,
    //                 title: {
    //                     text: 'Average Response Time'
    //                 },
    //                 data: [{
    //                     type: 'column',
    //                     dataPoints: this.cloudWatchLatency
    //                 }]
    //             });
    //             // latencyChart.render();
    //         }
    //
    //     } else {
    //         this.confPost.getCloudWatchLatencyMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
    //                 this.cloudWatchLatency = data;
    //                 this.platform.cloudWatchLatency = data;
    //                 if (this.cloudWatchLatency !== null && this.cloudWatchLatency !== undefined) {
    //                     const value = [];
    //                     const label = [];
    //                     for (let t = 0; t < this.cloudWatchLatency.length; t++) {
    //                         value.push(parseInt(this.cloudWatchLatency[t]['y']));
    //                         label.push(this.cloudWatchLatency[t]['label']);
    //                     }
    //                     this.barChartDataLatency[0].data = value;
    //                     this.barChartLabelsLatency = label;
    //
    //                     let latencyChart = new CanvasJS.Chart('chartContainer', {
    //                         animationEnabled: true,
    //                         exportEnabled: false,
    //                         title: {
    //                             text: 'Average Response Time'
    //                         },
    //                         data: [{
    //                             type: 'column',
    //                             dataPoints: this.cloudWatchLatency
    //                         }]
    //                     });
    //                     // latencyChart.render();
    //                 }
    //
    //             },
    //             error => {
    //                 // this.platform.openSnackBar('Error while getting latency metrics from CloudWatch: ' + error.error.message, 'Error', {
    //                 //     duration: 15000,
    //                 //     verticalPosition: 'top',
    //                 //     horizontalPosition: 'center'
    //                 // });
    //             });
    //     }
    // }

    stringifyjson(val) {
        return JSON.stringify(val);
    }

    getCloudWatchHitsMetrics() {
        // if (this.platform.cloudWatchNoOfHits !== null && this.platform.cloudWatchNoOfHits !== undefined) {
        //     this.cloudWatchNoOfHits = this.platform.cloudWatchNoOfHits;
        //     if (this.cloudWatchNoOfHits !== null && this.cloudWatchNoOfHits !== undefined) {
        //         const value = [];
        //         const label = [];
        //         for (let t = 0; t < this.cloudWatchNoOfHits.length; t++) {
        //             value.push(parseInt(this.cloudWatchNoOfHits[t]['y']));
        //             label.push(this.cloudWatchNoOfHits[t]['label']);
        //         }
        //         this.barChartData[0].data = value;
        //         this.barChartLabels = label;
        //
        //         let barChart = new CanvasJS.Chart('barChartContainer', {
        //             animationEnabled: true,
        //             exportEnabled: false,
        //             title: {
        //                 text: 'No. of API Hits'
        //             },
        //             data: [{
        //                 type: 'column',
        //                 dataPoints: this.cloudWatchNoOfHits
        //             }]
        //         });
        //         // barChart.render();
        //     }
        //
        // } else {
        //     this.confPost.getCloudWatchMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //             this.cloudWatchNoOfHits = data;
        //             this.platform.cloudWatchNoOfHits = data;
        //             if (this.cloudWatchNoOfHits !== null && this.cloudWatchNoOfHits !== undefined) {
        //                 const value = [];
        //                 const label = [];
        //                 for (let t = 0; t < this.cloudWatchNoOfHits.length; t++) {
        //                     value.push(parseInt(this.cloudWatchNoOfHits[t]['y']));
        //                     label.push(this.cloudWatchNoOfHits[t]['label']);
        //                 }
        //                 this.barChartData[0].data = value;
        //                 this.barChartLabels = label;
        //
        //                 let barChart = new CanvasJS.Chart('barChartContainer', {
        //                     animationEnabled: true,
        //                     exportEnabled: false,
        //                     title: {
        //                         text: 'No. of API Hits'
        //                     },
        //                     data: [{
        //                         type: 'column',
        //                         dataPoints: this.cloudWatchNoOfHits
        //                     }]
        //                 });
        //                 // barChart.render();
        //             }
        //         },
        //         error => {
        //             // this.platform.openSnackBar('Error while getting noOfHits metrics from CloudWatch: ' + error.error.message, 'Error', {
        //             //     duration: 5000,
        //             //     verticalPosition: 'top',
        //             //     horizontalPosition: 'center'
        //             // });
        //         });
        // }
    }

    async ngOnInit() {
        // this.platform.setGuideTourSteps(this.getDefaultControlPlaneTourSteps());
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        // if (this.platform.permissionsReceived !== true) {
        //     await this.platform.getAllPermissions();
        // }
        this.partner = localStorage.getItem('partner');
        this.account = localStorage.getItem('account');
        this.appComp.subMenuPanelExpanded = false;
        // this.gatewayUrl = (this.partner === this.account ? 'https://gateway.' + this.partner + '.apiplatform.io' : 'https://gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
        this.gatewayUrl = 'https://' + await this.platform.getDefaultGatewayURL();
        this.apiKey = localStorage.getItem('apikey');
        this.getMaxCount();
        this.itemList = [];
        for (let t = 0; t < this.columnSearch.length; t++) {
            if (this.columnSearch[t] !== '') {
                const tempObj = {};
                tempObj['id'] = t;
                tempObj['itemName'] = this.columns[t];
                tempObj['filter'] = this.columnSearch[t];
                this.itemList.push(tempObj);
            }
        }

        this.applicationFilterList = [];
        for (let t = 0; t < this.columnSearchApplication.length; t++) {
            if (this.columnSearchApplication[t] !== '') {
                const tempObj = {};
                tempObj['id'] = t;
                tempObj['itemName'] = this.applicationColumns[t];
                tempObj['filter'] = this.columnSearchApplication[t];
                this.applicationFilterList.push(tempObj);
            }
        }
        this.getCategoriesAndEntities();
        this.getStorageDetails();
        this.getEntityCountForPartner();
        this.getEntityCountForPartnerAccount();
        this.generateGraph();
        // this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.countPartnerAccountEntities = data;
        // });

        // this.getCloudWatchHitsMetrics();
        // this.getCloudWatchLatencyMetrics();

        // this.confPost.getCloudWatchMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.cloudWatchNoOfHits = data;
        //     const value = [];
        //     const label = [];
        //     for (let t = 0; t < this.cloudWatchNoOfHits.length; t++) {
        //         value.push(parseInt(this.cloudWatchNoOfHits[t]['y']));
        //         label.push(this.cloudWatchNoOfHits[t]['label']);
        //     }
        //     this.barChartData[0].data = value;
        //     this.barChartLabels = label;
        // });
        // this.confPost.getCloudWatchMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     let barChart = new CanvasJS.Chart('barChartContainer', {
        //         animationEnabled: true,
        //         exportEnabled: false,
        //         title: {
        //             text: 'No. of API Hits'
        //         },
        //         data: [{
        //             type: 'column',
        //             dataPoints: data
        //         }]
        //     });
        //       barChart.render();
        // });
        // this.confPost.getCloudWatchLatencyMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     let latencyChart = new CanvasJS.Chart('chartContainer', {
        //         animationEnabled: true,
        //         exportEnabled: false,
        //         title: {
        //             text: 'Average Response Time'
        //         },
        //         data: [{
        //             type: 'column',
        //             dataPoints: data
        //         }]
        //     });
        //       latencyChart.render();
        // });
        // this.confPost.getCloudWatchLatencyMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.cloudWatchLatency = data;
        //     const value = [];
        //     const label = [];
        //     for (let t = 0; t < this.items.length; t++) {
        //         value.push(parseInt(this.items[t]['y']));
        //         label.push(this.items[t]['label']);
        //     }
        //     this.barChartDataLatency[0].data = value;
        //     this.barChartLabelsLatency = label;
        // });
        // this.getApiExecutorsByPartnerAccount();
        this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());

        await this.getApiExecutorsByPartnerAccountType();
        // this.getBusinessLogicApiExecutorsByPartnerAccountType();
        // this.getThirdPartyApiExecutorsByPartnerAccountType();
        // this.getSqlQueryApiExecutorsByPartnerAccountType();
        // this.getTestSuiteApiExecutorsByPartnerAccountType();
        // this.getWorkFlowApiExecutorsByPartnerAccountType();
        // this.getPLSQLApiExecutorsByPartnerAccountType();
        this.getApplicationsByPartnerAccount();
        // this.getb2bAPIs();
        // this.getDMNApiExecutorsByPartnerAccountType();
        this.loading = false;
        // this.platform.setGuideTourSteps(this.getControlPlaneTourSteps());

    }

    removeIndexInmfData(entity, version) {
        const itemDuplicate = this.item;
        const deleteditem = itemDuplicate.findIndex(p => p && this.getValue(p.APIs) === entity && this.getVersion(p.APIs) === version);
        delete this.item[deleteditem];
        this.searchText = '';
    }

    deleteApi(entity: string, version: string, event) {
        if (confirm('You are about to delete the API which is irreversible. However we would back your data up which will be hooked up automatically with your API if you create it with the same name and schema. Are you sure you want to delete this API?')) {
            this.confPost.deleteEntity(this.partner, this.account, this.partnerKey, entity, version).subscribe(data => {
                this.platform.openSnackBar('Deleted the API successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                const itemDuplicate = this.item;
                const deleteditem = itemDuplicate.findIndex(p => p && this.getValue(p.APIs) === entity);
                delete this.item[deleteditem];
                // this.router.navigate(['/controlplane']);
            }, error => {
                this.platform.openSnackBar('Error while deleting the API', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });

            // this._service.postAuditItemDelete(version, this.partner, this.account, entity).subscribe(
            //     status => {
            //     }, error => {
            //         this.platform.openSnackBar('Error while adding audit details for the Entity Deletion', 'Error', {
            //             duration: 5000,
            //         });
            //     });
        }

    }

    getValue(val) {
        if (val) {
            const data = val.split('#');
            /* var str = Object.values(val).toString();
             return str.substr(0, str.indexOf('.')).toString();*/
            return data[0];
        }
    }

    getVersion(val) {
        if (val) {
            /* var str = Object.values(val).toString();
         return str.substr(str.indexOf('.') + 1, str.length);*/
            const data = val.split('#');
            return data[1];
        }
    }

    getCreatedDate(val) {
        // const data = val.split('#');
        // if (Number(data[2]) !== 0) {
        //     return new Date(Number(data[2])).toLocaleString();
        // } else {
        //     return new Date(Date.now() - Number(this.getTotalUptime(val)) * 1000 * 60 * 60).toLocaleString();
        // }

        if (val) {
            return this.platform.timeConverter(val);
        } else {
            return '';
        }

    }

    getLastModifiedData(val, val1) {
        if (val) {
            return this.platform.timeConverter(val);
        } else {
            if (val1) {
                return this.platform.timeConverter(val1);
            } else {
                return '';
            }
        }
    }

    getMonthlyUptime(val) {
        const data = val.split('#');
        return data[3];
    }

    getTotalUptime(val) {
        const data = val.split('#');
        return data[6];
    }

    getMonthlyBillAmount(val) {
        const data = val.split('#');
        return data[4];
    }

    getMonthlyForecast(val) {
        const data = val.split('#');
        return data[5];
    }

    getTotalBillAmount(val) {
        const data = val.split('#');
        return data[7];
    }

    getApiStatus(val) {
        const data = val.split('#');
        return data[8];
    }

    getApiIsPublished(val) {
        const data = val.split('#');
        return data[9];
    }

    getKey(val) {
        return Object.keys(val);
    }

    bytesToSize(bytes) {
        if (bytes !== null && bytes !== undefined) {
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) {
                return '0 Byte';
            }
            const i = Math.floor(Math.log(bytes) / Math.log(1024));
            return Math.round((bytes / Math.pow(1024, i))) + ' ' + sizes[i];
        }
    }

    promoteAPI(item) {
        this.dialog.open(PromoteToEnvironmentComponent, {
            height: '40%',
            width: '30%',
            data: {partner: this.partner, account: this.account, entity: item.entityname, version: item.version, type: 'DATAACCESS'}
        });
    }

    openGitHubDialog(partner, account, entityname, version, type) {
        const dialogRef = this.dialog.open(GithubConnectionComponent, {
            minWidth: '30vw',
            data: {
                partner: partner,
                account: account,
                entityname: entityname,
                version: version,
                type: type
            }
        });
    }

    generateGraph() {
        let consumer = localStorage.getItem('signInEmail');
        consumer = consumer.replace('@', '_');
        const payload = {
            graph_json: {
                'viz': 'query_value',
                'requests': [
                    {
                        'response_format': 'scalar',
                        'queries': [
                            {
                                'name': 'query1',
                                'data_source': 'metrics',
                                'query': 'sum:apiplatform.request.count{consumer:' + consumer + '}.as_count()',
                                'aggregator': 'sum'
                            }
                        ],
                        'conditional_formats': [],
                        'formulas': [
                            {
                                'formula': 'query1'
                            }
                        ]
                    }
                ],
                'precision': 2,
                'autoscale': true,
                'timeseries_background': {
                    'type': 'bars'
                }
            },
            legend: 'yes',
            timeframe: '1_week',
            size: 'medium',
            title: 'Total Request' + ' : ' + consumer,
        };
        const payload1 = {
            graph_json: {
                'viz': 'timeseries',
                'requests': [
                    {
                        'style': {
                            'palette': 'dog_classic',
                            'type': 'solid',
                            'width': 'normal'
                        },
                        'type': 'bars',
                        'formulas': [
                            {
                                'formula': 'query1'
                            }
                        ],
                        'queries': [
                            {
                                'name': 'query1',
                                'data_source': 'metrics',
                                'query': 'avg:apiplatform.latency.avg{consumer:' + consumer + '}'
                            }
                        ],
                        'response_format': 'timeseries'
                    }
                ]
            },
            legend: 'yes',
            timeframe: '1_week',
            size: 'medium',
            title: 'Average Latency' + ' : ' + consumer,
        };
        this.confPost.getEmbeddedGraph(payload).subscribe(response => {
            if (response) {
                this.computedGraphs.push(response);
            }
            this.confPost.getEmbeddedGraph(payload1).subscribe(response1 => {
                if (response) {
                    this.computedGraphs.push(response1);
                }
            });
        });
    }

}

@Component({
    selector: 'github-connection-dialog',
    templateUrl: 'github-connection.html',
    styleUrls: ['github-connection.css'],
})
export class GithubConnectionComponent implements OnInit {
    accessToken = '';
    github_handle = '';
    github_repo = [];
    github_branches = [];
    isConnected = false;
    selectedRepo = '';
    selectedBranch = '';
    isEdit = false;
    id: any;
    selectedCode = 'Python';
    codes = ['Python', 'Java'];
    path = '';
    repoPath = '';
    filePath = '';
    fileName = '';
    isCommitted: boolean;
    committedFilePath = '';
    committedRepoPath = '';
    committedBranch = '';
    committedPath = '';
    committedSha = '';
    committedFileName = '';
    incorrectToken = false;
    defaultPath = '';
    author = '';
    committedDate = '';
    commitPath = '';
    isRedeployed = false;
    executorData: any;
    newRepo = '';
    packageType: string;
    defaultpackage = '';
    custompackage = '';
    commitMessage = '';
    code = '';
    viewCode = false;
    sourceCodeFilesList = [];
    selectedFile = '';
    codeList = [];

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<GithubConnectionComponent>, public confPost: ConfService) {
        this.selectedCode = 'Python';
        this.defaultpackage = 'io.apiplatform.' + this.data['version'] + '.' + this.data['entityname'];
        this.packageType = this.defaultpackage;
        this.viewCode = true;
        this.viewSourceCode();
    }

    ngOnInit() {
    }

    createRepository() {
        const payload = {
            'name': this.newRepo
        };
        this.confPost.createGitRepo(this.accessToken, payload).subscribe(res => {
            if (res) {

                this.platform.openSnackBar('GitHub repository created.', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.confPost.getGitUserRepo(this.accessToken).subscribe(res1 => {
                    this.github_repo = [];
                    let temp: any = res1;
                    if (res1) {
                        for (let i = 0; i < temp.length; i++) {
                            if (temp[i]['owner']['login'] === this.github_handle) {
                                this.github_repo.push(temp[i]['name']);
                            }
                        }
                    }
                    this.selectedRepo = this.newRepo;
                    this.newRepo = '';
                    // this.onChangeRepo(this.newRepo);
                    this.github_branches = ['main'];
                    this.repoPath = this.github_handle + '/' + this.selectedRepo;
                    this.defaultPath = this.github_handle + '/' + this.selectedRepo + '/';
                });
            }
        }, err1 => {
            this.platform.openSnackBar('Failed to create new repository, Please try again.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    checkForAttributesChange(value, other) {
        let type = Object.prototype.toString.call(value);
        if (type !== Object.prototype.toString.call(other)) {
            return false;
        }
        if (['[object Array]', '[object Object]'].indexOf(type) < 0) {
            return false;
        }
        let valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
        let otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
        if (valueLen !== otherLen) {
            return false;
        }
        if (type === '[object Array]') {
            for (let i = 0; i < valueLen; i++) {
                if (this.compare(value[i], other[i]) === false) {
                    return false;
                }
            }
        } else {
            for (let key in value) {
                if (value.hasOwnProperty(key)) {
                    if (this.compare(value[key], other[key]) === false) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    compare(item1, item2) {
        const itemType = Object.prototype.toString.call(item1);
        if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
            if (!this.checkForAttributesChange(item1, item2)) {
                return false;
            }
        } else {
            if (itemType !== Object.prototype.toString.call(item2)) {
                return false;
            }
            if (itemType === '[object Function]') {
                if (item1.toString() !== item2.toString()) {
                    return false;
                }
            } else {
                if (item1 !== item2) {
                    return false;
                }
            }
        }
    }

    generateAccessToken() {
        window.open('https://github.com/settings/tokens', '_blank').focus();
    }

    submitAccessToken() {
        this.confPost.getGitUser(this.accessToken).subscribe(res => {
            if (res && res['login'].length > 0) {
                this.github_handle = res['login'];
                if (!this.isRedeployed) {
                    this.defaultPath = this.github_handle + '/';
                }
                this.confPost.getGitUserRepo(this.accessToken).subscribe(res1 => {
                    this.github_repo = [];
                    let temp: any = res1;
                    if (res1) {
                        for (let i = 0; i < temp.length; i++) {
                            if (temp[i]['owner']['login'] === this.github_handle) {
                                this.github_repo.push(temp[i]['name']);
                            }
                        }
                    }
                    this.isConnected = true;
                    this.incorrectToken = false;
                });
            }
        }, error => {
            this.isConnected = false;
            this.incorrectToken = true;
        });

    }

    onChangeRepo(repo) {
        this.github_branches = [];
        this.confPost.getGitUserBranch(this.accessToken, this.github_handle, repo).subscribe(res1 => {
            let temp: any = res1;
            if (res1) {
                for (let i = 0; i < temp.length; i++) {
                    this.github_branches.push(temp[i]['name']);
                }
            }
            if (this.github_branches.length === 0) {
                this, this.github_branches.push('main');
            }
        });
        this.repoPath = this.github_handle + '/' + this.selectedRepo;
        this.defaultPath = this.github_handle + '/' + this.selectedRepo + '/';

    }

    onChangeLanguage(language) {
        if (this.viewCode) {
            this.viewSourceCode();
        }
    }

    onChangeFile(index) {
        if (this.selectedCode === 'Java') {
            if (index === '0') {
                this.code = this.codeList[6];
            } else if (index === '1') {
                this.code = this.codeList[3];
            } else if (index === '2') {
                this.code = this.codeList[4];
            } else if (index === '3') {
                this.code = this.codeList[5];
            } else if (index === '4') {
                this.code = this.codeList[0];
            } else if (index === '5') {
                this.code = this.codeList[2];
            } else if (index === '6') {
                this.code = this.codeList[1];
            }
        } else {
            this.code = this.codeList[0];
        }
    }

    downloadCode() {
        if (this.selectedCode === 'Python') {
            saveAs(new Blob([this.code]), this.sourceCodeFilesList[0]);

        }
        if (this.selectedCode === 'Java') {
            const zip = new JSZip();
            const packagepath = this.packageType.split('.').join('/');
            const zipFolderName = this.data['entityname'] + '.zip';
            zip.file(this.data['entityname'] + '/' + this.sourceCodeFilesList[4], this.codeList[0]);
            zip.file(this.data['entityname'] + '/src/main/resources/' + this.sourceCodeFilesList[5], this.codeList[2]);
            zip.file(this.data['entityname'] + '/src/main/java/' + packagepath + '/model/' + this.sourceCodeFilesList[1], this.codeList[3]);
            zip.file(this.data['entityname'] + '/src/main/java/' + packagepath + '/repository/' + this.sourceCodeFilesList[2], this.codeList[4]);
            zip.file(this.data['entityname'] + '/src/main/java/' + packagepath + '/resource/' + this.sourceCodeFilesList[3], this.codeList[5]);
            zip.file(this.data['entityname'] + '/src/main/java/' + packagepath + '/' + this.sourceCodeFilesList[0], this.codeList[6]);
            zip.file(this.data['entityname'] + '/src/test/java/' + packagepath + '/' + this.sourceCodeFilesList[6], this.codeList[1]);

            zip.generateAsync({type: 'blob'}).then(function (content) {
                // see FileSaver.js
                saveAs(content, zipFolderName);
            });
        }
    }

    closeSourceCode() {
        this.viewCode = false;
    }

    viewSourceCode() {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.getEntity(this.data['partner'], this.data['account'], this.data['entityname'], this.data['version']).subscribe(resp => {
            if (resp && resp !== undefined && resp !== null && resp['methods'] && resp['methods'] !== null && resp['methods'] !== undefined) {
                const data = resp;
                if (this.selectedCode === 'Java' && this.packageType !== this.defaultpackage) {
                    this.packageType = this.custompackage;
                }
                if (this.selectedCode === 'Java' && this.packageType === this.defaultpackage) {
                    this.custompackage = '';
                }
                const generatedCode = this.generateCode(data, this.selectedCode);
                this.codeList = generatedCode;
                if (this.selectedCode === 'Python') {
                    this.code = generatedCode[0];
                    const filename = this.data['entityname'] + '.py';
                    this.sourceCodeFilesList = [filename];
                    this.selectedFile = '0';
                } else if (this.selectedCode === 'Java') {
                    this.code = generatedCode[6];
                    const classfilename = this.data['entityname'].charAt(0).toUpperCase() + this.data['entityname'].slice(1) + '.java';
                    this.selectedFile = '0';
                    const repofilename = this.data['entityname'].charAt(0).toUpperCase() + this.data['entityname'].slice(1) + 'Repository.java';
                    const controllerfilename = this.data['entityname'].charAt(0).toUpperCase() + this.data['entityname'].slice(1) + 'Controller.java';
                    const applicationfilename = this.data['entityname'].charAt(0).toUpperCase() + this.data['entityname'].slice(1) + 'Application.java';
                    const testfilename = this.data['entityname'].charAt(0).toUpperCase() + this.data['entityname'].slice(1) + 'ApplicationTests.java';
                    this.sourceCodeFilesList = [applicationfilename, classfilename, repofilename, controllerfilename, 'pom.xml', 'application.properties', testfilename];
                }
                this.viewCode = true;
                loaderDialog.close();

            }
        }, err => {
            loaderDialog.close();
            this.platform.openSnackBar('Error in viewing source code. Please try again later.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    viewCommitPage() {

        const queryParam = 'account=' + this.data['account'] + '&partner=' + this.data['partner'] + '&entity_name=' + this.data['entityname'] + '&version=' + this.data['version'];
        this.confPost.getData('services', 'services', 'v1', 'githubCommits', queryParam).subscribe(res => {
            if (res && res !== undefined && res !== null) {
                const temp: any = res;
                if (temp.length > 0) {
                    this.isCommitted = true;
                    const latestCommitDate = new Date(Math.max.apply(null, temp.map(function (e) {
                        return new Date(e.commit_date);
                    })));
                    for (const item of temp) {
                        if (String(new Date(item['commit_date'])) === String(latestCommitDate)) {
                            this.committedFilePath = item['file_path'];
                            this.author = item['author'];
                            this.committedDate = item['commit_date'];
                            this.commitPath = item['commit_path'];
                            this.defaultPath = item['repository_path'] + '/';
                            this.committedRepoPath = item['repository_path'];
                            this.committedPath = item['path'];
                            this.selectedBranch = item['branch'];
                            this.selectedCode = item['code'];
                            this.path = item['path'];
                            this.selectedRepo = item['repository_path'].split('/')[1];
                            this.committedSha = item['sha'];
                            this.committedFileName = item['file_name'];
                            this.commitMessage = item['commit_message'];
                            const committedAttributes = item['attributes'];
                            this.confPost.getEntity(this.data['partner'], this.data['account'], this.data['entityname'], this.data['version']).subscribe(resp => {
                                if (resp && resp !== undefined && resp !== null && resp['methods'] && resp['methods'] !== null && resp['methods'] !== undefined) {
                                    const data1 = resp;
                                    this.executorData = resp;
                                    const sameAttributes = this.checkForAttributesChange(JSON.parse(committedAttributes), data1['attributes']);
                                    if (sameAttributes === true) {
                                        this.isRedeployed = false;
                                    } else {
                                        this.isRedeployed = true;
                                    }

                                }
                            });
                        }
                    }
                } else {
                    this.isCommitted = false;
                }
            } else {
                this.isCommitted = false;
            }
        }, error => {
            this.isCommitted = false;
        });
    }

    generateCode(data, code) {
        let codeArray = [];
        if (code === 'Python') {
            let PySnippet = '';
            if (data['database'].startsWith('sql')) {
                PySnippet = `from flask import Flask, request, redirect ,  json, Response
import pyodbc

app = Flask(__name__)

def connection():
    server = 'myserver'
    database = '` + data['database'] + `'
    username = 'myusername'
    password = 'mypassword'
    connection_str = 'DRIVER={ODBC Driver 17 for SQL Server};SERVER=' + server + ';DATABASE=' + database + ';UID=' + username + ';PWD=' + password
    conn = pyodbc.connect(connection_str)
    return conn

@app.route('/` + data['entityname'] + `', methods=['GET'])
def read_data():
    output = []
    conn = connection()
    cursor = conn.cursor()
    cursor.execute("SELECT * FROM ` + data['tableName'] + `")
    for row in cursor.fetchall():
        output.append(row)
    conn.close()
    return Response(response=json.dumps(output), status=200,
                    mimetype='application/json')

@app.route('/` + data['entityname'] + `', methods=['POST'])
def create():
    if request.method == 'POST':
        data = request.json
        conn = connection()
        cursor = conn.cursor()
        response = cursor.execute("INSERT INTO ` + data['tableName'] + ` (`;
                for (let item of data['attributes']) {
                    PySnippet = PySnippet + item['attributeName'] + ',';
                }
                PySnippet = PySnippet.slice(0, -1);
                PySnippet = PySnippet + `) VALUES ( `;
                for (let item of data['attributes']) {
                    PySnippet = PySnippet + `data['` + item['attributeName'] + `'],`;
                }
                PySnippet = PySnippet.slice(0, -1);
                PySnippet = PySnippet + `)")
        conn.commit()
        conn.close()
        return Response(response=json.dumps(response), status=200,
                        mimetype='application/json')

@app.route('/` + data['entityname'] + `', methods = ['PUT'])
def update():
    data = request.json
    cr = []
    conn = connection()
    cursor = conn.cursor()
    if request.method == 'PUT':
        response = cursor.execute("UPDATE ` + data['tableName'] + ` SET `;
                for (let item of data['attributes']) {
                    PySnippet = PySnippet + item['attributeName'] + ' = ?,';
                }
                PySnippet = PySnippet.slice(0, -1);
                PySnippet = PySnippet + ` WHERE `;
                for (let item of data['attributes']) {
                    if (item['attributeType'] !== 'None') {
                        PySnippet = PySnippet + item['attributeName'];
                        break;
                    }
                }
                PySnippet = PySnippet + ` = ?", `;
                for (let item of data['attributes']) {
                    PySnippet = PySnippet + `data['` + item['attributeName'] + `'],`;
                }
                for (let item of data['attributes']) {
                    if (item['attributeType'] !== 'None') {
                        PySnippet = PySnippet + `data['` + item['attributeName'] + `'],`;
                        break;
                    }
                }
                PySnippet = PySnippet + `)
        conn.commit()
        conn.close()
        return Response(response=json.dumps(response), status=200,
                        mimetype='application/json')
    
@app.route('/` + data['entityname'] + `', methods = ['DELETE'])
def delete():
    data = request.json
    conn = connection()
    cursor = conn.cursor()
    response = cursor.execute("DELETE FROM ` + data['tableName'] + ` WHERE `;
                for (let item of data['attributes']) {
                    if (item['attributeType'] !== 'None') {
                        PySnippet = PySnippet + item['attributeName'] + ` = ?", data['` + item['attributeName'];
                        break;
                    }
                }
                PySnippet = PySnippet + `'])
    conn.commit()
    conn.close()
    return Response(response=json.dumps(response), status=200,
                    mimetype='application/json')

if(__name__ == "__main__"):
    server = 'myserver'
    database = 'mydb'
    username = 'myusername'
    password = 'mypassword'
    connection_str = 'DRIVER={ODBC Driver 17 for SQL Server};SERVER=' + server + ';DATABASE=' + database + ';UID=' + username + ';PWD=' + password
    conn = pyodbc.connect(connection_str)
    cursor = conn.cursor()
    cursor.execute(' CREATE TABLE ` + data['tableName'] + ` ( `;
                for (let item of data['attributes']) {
                    PySnippet = PySnippet + item['attributeName'] + ' ' + item['type'] + '(' + item['size'] + ')';
                    if (item['attributeType'] === 'Primary') {
                        PySnippet = PySnippet + ' PRIMARY KEY';
                    }
                    if (item['required'] === true) {
                        PySnippet = PySnippet + ' NOT NULL,';
                    } else {
                        PySnippet = PySnippet + ',';
                    }
                }
                PySnippet = PySnippet.slice(0, -1);
                PySnippet = PySnippet + `)')
    conn.commit()
    app.run(debug=True, port=5000)
`;

            } else {
                let required_fields = '';
                for (const api of data['attributes']) {
                    if (api['required'] === true) {
                        required_fields = required_fields + '"' + api['attributeName'] + '",';
                    }
                }
                required_fields = required_fields.slice(0, -1);
                let properties = `"properties": {
                                     "`;
                for (const api of data['attributes']) {
                    properties = properties + api['attributeName'] + `": {
                                         "bsonType": "` + api['type'] + `",
                                     },
                                     "`;
                }
                properties = properties.slice(0, -1);
                properties = properties + `
                                 }`;
                PySnippet = `from flask import Flask, request, json, Response
from pymongo import MongoClient


app = Flask(__name__)

class `;
                PySnippet = PySnippet + data['tableName'] + `:
    def __init__(self, data):
        self.client = MongoClient("mongodb://localhost:27017/")
        database = '`;
                PySnippet = PySnippet + data['database'] + `'
        collection = '`;
                PySnippet = PySnippet + data['tableName'] + `'
        cursor = self.client[database]
        self.collection = cursor[collection]
        self.data = data

    def insert_data(self, data):
        new_document = data['document']
        response = self.collection.insert_one(new_document)
        output = {'Status': 'Successfully Inserted',
                  'Document_ID': str(response.inserted_id)}
        return output

    def read(self):
        documents = self.collection.find()
        output = [{item: data[item] for item in data if item != '_id'} for data in documents]
        return output

    def update_data(self):
        filter = self.data['condition']
        updated_data = {"$set": self.data['DataToBeUpdated']}
        response = self.collection.update_one(filter, updated_data)
        output = {'Status': 'Successfully Updated' if response.modified_count > 0 else "Nothing was updated."}
        return output

    def delete_data(self, data):
        filter = data['condition']
        response = self.collection.delete_one(filter)
        output = {'Status': 'Successfully Deleted' if response.deleted_count > 0 else "Document not found."}
        return output


@app.route('/`;
                PySnippet = PySnippet + data['entityname'] + `', methods=['GET'])
def read_data():
    # sample request payload { }
    data = {}
    read_obj = `;
                PySnippet = PySnippet + data['tableName'] + `(data)
    response = read_obj.read()
    return Response(response=json.dumps(response), status=200,
                    mimetype='application/json')


@app.route('/`;
                PySnippet = PySnippet + data['entityname'] + `', methods=['POST'])
def create():
    # sample request payload { 'document':{ data } }
    data = request.json
    if data is None or data == {} or 'document' not in data:
        return Response(response=json.dumps({"Error": "Please provide connection information"}),
                        status=400, mimetype='application/json')
    create_obj = `;
                PySnippet = PySnippet + data['tableName'] + `(data)
    response = create_obj.insert_data(data)
    return Response(response=json.dumps(response), status=200,
                    mimetype='application/json')

@app.route('/`;
                PySnippet = PySnippet + data['entityname'] + `', methods=['PUT'])
def update():
    # sample request payload { 'database':'demo', 'collection':'demo', 'condition':{ 'id':1 }, 'DataToBeUpdated':{ data to be updated } }
    data = request.json
    if data is None or data == {} or 'condition' not in data:
        return Response(response=json.dumps({"Error": "Please provide connection information"}),
                        status=400, mimetype='application/json')
    update_obj = `;
                PySnippet = PySnippet + data['tableName'] + `(data)
    response = update_obj.update_data()
    return Response(response=json.dumps(response), status=200,
                    mimetype='application/json')

@app.route('/`;
                PySnippet = PySnippet + data['entityname'] + `', methods=['PATCH'])
def update_one():
    # sample request payload { 'database':'demo', 'collection':'demo', 'condition':{ 'id':1 }, 'DataToBeUpdated':{ data to be updated } }
    data = request.json
    if data is None or data == {} or 'condition' not in data:
        return Response(response=json.dumps({"Error": "Please provide connection information"}),
                        status=400, mimetype='application/json')
    update_obj = `;
                PySnippet = PySnippet + data['tableName'] + `(data)
    response = update_obj.update_data()
    return Response(response=json.dumps(response), status=200,
                    mimetype='application/json')


@app.route('/`;
                PySnippet = PySnippet + data['entityname'] + `', methods=['DELETE'])
def delete():
    # sample request payload { 'database':'demo', 'collection':'demo', 'condition':{ 'id':1 } }
    data = request.json
    if data is None or data == {} or 'condition' not in data:
        return Response(response=json.dumps({"Error": "Please provide connection information"}),
                        status=400, mimetype='application/json')
    delete_obj = `;
                PySnippet = PySnippet + data['tableName'] + `(data)
    response = delete_obj.delete_data(data)
    return Response(response=json.dumps(response), status=200,
                    mimetype='application/json')

if __name__ == '__main__':
    myclient = MongoClient("mongodb://localhost:27017/")
    mydb = myclient["` + data['database'] + `"]
    collection_list = mydb.list_collection_names()
    if '`;
                PySnippet = PySnippet + data['tableName'] + `' not in collection_list:
        mydb.create_collection(name='`;
                PySnippet = PySnippet + data['tableName'] + `',
                             validator={"$jsonSchema": {
                                 "bsonType": "object",
                                 "required": [` + required_fields + `],
                                 ` + properties + `
                             }},
                             validationAction="error",)
    print('collection list ',mydb.list_collection_names())
    app.run(debug=True, port=5000)`;

            }

            codeArray.push(PySnippet);

            return codeArray;
        }
        if (code === 'Java') {
            const xml_code = `<?xml version="1.0" encoding="UTF-8"?>
<project xmlns="http://maven.apache.org/POM/4.0.0" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
	xsi:schemaLocation="http://maven.apache.org/POM/4.0.0 https://maven.apache.org/xsd/maven-4.0.0.xsd">
	<modelVersion>4.0.0</modelVersion>
	<parent>
		<groupId>org.springframework.boot</groupId>
		<artifactId>spring-boot-starter-parent</artifactId>
		<version>2.7.0</version>
		<relativePath/> <!-- lookup parent from repository -->
	</parent>
	<groupId>io.apiplatform.v1</groupId>
	<artifactId>` + data['entityname'].toLowerCase() + `</artifactId>
	<version>0.0.1-SNAPSHOT</version>
	<name>` + data['entityname'].toLowerCase() + `</name>
	<description>apiplatform.io</description>
	<properties>
		<java.version>1.8</java.version>
	</properties>
	<dependencies>
		<dependency>
			<groupId>org.springframework.boot</groupId>
			<artifactId>spring-boot-starter-data-mongodb</artifactId>
		</dependency>
		<dependency>
			<groupId>org.springframework.boot</groupId>
			<artifactId>spring-boot-starter-web</artifactId>
		</dependency>

		<dependency>
			<groupId>org.springframework.boot</groupId>
			<artifactId>spring-boot-starter-test</artifactId>
			<scope>test</scope>
		</dependency>
	</dependencies>

	<build>
		<plugins>
			<plugin>
				<groupId>org.springframework.boot</groupId>
				<artifactId>spring-boot-maven-plugin</artifactId>
			</plugin>
		</plugins>
	</build>

</project>
`;
            codeArray.push(xml_code);
            const test_code = `package ` + this.packageType + `;

import org.junit.jupiter.api.Test;
import org.springframework.boot.test.context.SpringBootTest;

@SpringBootTest
class ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `ApplicationTests {

	@Test
	void contextLoads() {
	}

}
`;
            codeArray.push(test_code);
            const appication_code = `spring.data.mongodb.host=localhost
spring.data.mongodb.port=27017
spring.data.mongodb.database=` + data['database'];
            codeArray.push(appication_code);

            let model_code = `package ` + this.packageType + `.model;


import org.springframework.data.annotation.Id;
import org.springframework.data.mongodb.core.mapping.Document;


@Document(collection = "` + data['tableName'] + `")
public class ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + ` {

    @Id
    private String id;
    `;
            for (let item of data['attributes']) {
                model_code = model_code + 'private ' + item['type'] + ' ' + item['attributeName'] + `;
    `;
            }
            model_code = model_code + `
    `;
            for (let item of data['attributes']) {
                model_code = model_code + 'public ' + item['type'] + ' ' + 'get' + item['attributeName'].charAt(0).toUpperCase() + item['attributeName'].slice(1) + `() {
        return ` + item['attributeName'] + `;
    }

    public void set` + item['attributeName'].charAt(0).toUpperCase() + item['attributeName'].slice(1) + `(` + item['type'] + ` ` + item['attributeName'] + `) {
        this.` + item['attributeName'] + ` = ` + item['attributeName'] + `;
    }
    `;
            }
            model_code = model_code + `
    public String getId() {
        return id;
    }

    public void setId(String id) {
        this.id = id;
    }
    
}
`;
            codeArray.push(model_code);

            const repository_code = `package ` + this.packageType + `.repository;

import ` + this.packageType + `.model.` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `;
import org.springframework.data.mongodb.repository.MongoRepository;

public interface ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `Repository extends MongoRepository<` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `,String> {
}
`;
            codeArray.push(repository_code);

            let controller_code = `package ` + this.packageType + `.resource;

import ` + this.packageType + `.model.` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `;
import ` + this.packageType + `.repository.` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `Repository;
import org.springframework.beans.factory.annotation.Autowired;
import org.springframework.http.HttpStatus;
import org.springframework.http.ResponseEntity;
import org.springframework.web.bind.annotation.*;

import java.util.List;
import java.util.Optional;

@RestController
public class ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `Controller {

    @Autowired
    private ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `Repository repository;

    @GetMapping("/` + data['entityname'].toLowerCase() + `")
    public List<` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `> get` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `Data(){
        return repository.findAll();
    }

    @PostMapping("/` + data['entityname'].toLowerCase() + `")
    public String save` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `(@RequestBody ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + ` ` + data['entityname'].toLowerCase() + `) {
        repository.save(` + data['entityname'].toLowerCase() + `);
        return "Added ` + data['entityname'].toLowerCase() + ` data";
    }

    @GetMapping("/` + data['entityname'].toLowerCase() + `/{id}")
    public Optional<` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `> get` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `(@PathVariable String id) {
        return repository.findById(id);
    }

    @DeleteMapping("/` + data['entityname'].toLowerCase() + `/{id}")
    public String delete` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `(@PathVariable String id) {
        repository.deleteById(id);
        return "` + data['entityname'].toLowerCase() + ` deleted with id : " + id;
    }

    @PutMapping("/` + data['entityname'].toLowerCase() + `/{id}")
    public ResponseEntity<` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `> update` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `(@PathVariable String id, @RequestBody ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + ` ` + data['entityname'].toLowerCase() + `) {
        Optional<` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `> ` + data['entityname'].toLowerCase() + `Data = repository.findById(id);
        if (` + data['entityname'].toLowerCase() + `Data.isPresent()) {
            ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + ` _` + data['entityname'].toLowerCase() + ` = ` + data['entityname'].toLowerCase() + `Data.get();
            `;
            for (let item of data['attributes']) {
                controller_code = controller_code + '_' + data['entityname'].toLowerCase() + '.set' + item['attributeName'].charAt(0).toUpperCase() + item['attributeName'].slice(1) + '(' + data['entityname'] + '.get' + item['attributeName'].charAt(0).toUpperCase() + item['attributeName'].slice(1) + `());
            `;

            }
            controller_code = controller_code + `
            return new ResponseEntity<>(repository.save(_` + data['entityname'].toLowerCase() + `), HttpStatus.OK);
        } else {
            return new ResponseEntity<>(HttpStatus.NOT_FOUND);
        }
    }

}
`;
            codeArray.push(controller_code);
            const main_code = `package ` + this.packageType + `;

import org.springframework.boot.SpringApplication;
import org.springframework.boot.autoconfigure.SpringBootApplication;

@SpringBootApplication
public class ` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `Application {

	public static void main(String[] args) {
		SpringApplication.run(` + data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + `Application.class, args);
	}

}
`;
            codeArray.push(main_code);
            return codeArray;

        }

        return codeArray;
    }

    commitToGitHub() {
        this.confPost.getEntity(this.data['partner'], this.data['account'], this.data['entityname'], this.data['version']).subscribe(resp => {
            if (resp && resp !== undefined && resp !== null && resp['methods'] && resp['methods'] !== null && resp['methods'] !== undefined) {
                const data = resp;
                // console.log(resp);
                this.fileName = data['entityname'] + '.py';
                this.filePath = this.path;
                if (this.filePath === '') {
                    this.filePath = this.fileName;
                } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                    this.filePath = this.filePath + this.fileName;
                } else {
                    this.filePath = this.filePath + '/' + this.fileName;
                }
                const generatedCode = this.generateCode(data, this.selectedCode);
                // console.log(generatedCode);
                const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                });
                if (!this.isRedeployed) {
                    if (this.selectedCode === 'Python') {
                        this.confPost.commitToGitHub(this.data['account'], this.accessToken, this.selectedBranch, this.repoPath, this.filePath, this.fileName, btoa(generatedCode[0]), this.commitMessage).subscribe(res => {
                            this.isCommitted = true;
                            loaderDialog.close();
                            this.committedFilePath = res['content']['html_url'];
                            const payload = {
                                'account': this.data['account'],
                                'partner': this.data['partner'],
                                'entity_name': this.data['entityname'],
                                'version': this.data['version'],
                                'file_path': this.committedFilePath,
                                'commit_path': res['commit']['html_url'],
                                'author': res['commit']['author']['email'],
                                'commit_date': res['commit']['author']['date'],
                                'sha': res['content']['sha'],
                                'attributes': JSON.stringify(data['attributes']),
                                'repository_path': this.repoPath,
                                'branch': this.selectedBranch,
                                'path': this.filePath,
                                'file_name': this.fileName,
                                'code': this.selectedCode,
                                'commit_message': this.commitMessage
                            };
                            this.author = res['commit']['author']['email'];
                            this.committedDate = res['commit']['author']['date'];
                            this.commitPath = res['commit']['html_url'];

                            this.confPost.addItemServices('v1', 'githubCommits', payload).subscribe(res => {
                            });
                        }, err => {
                            loaderDialog.close();
                            this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                    } else if (this.selectedCode === 'Java') {
                        const packagepath = this.packageType.split('.').join('/');
                        for (let i = 0; i < generatedCode.length; i++) {

                            setTimeout(() => {

                                    if (i === 0) {
                                        this.filePath = this.path;
                                        this.fileName = 'pom.xml';
                                        if (this.filePath === '') {
                                            this.filePath = data['entityname'] + '/' + this.fileName;
                                        } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                                            this.filePath = this.filePath + data['entityname'] + '/' + this.fileName;
                                        } else {
                                            this.filePath = this.filePath + '/' + data['entityname'] + '/' + this.fileName;
                                        }
                                    }
                                    if (i === 1) {
                                        this.filePath = this.path;
                                        this.fileName = data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + 'ApplicationTests.java';
                                        if (this.filePath === '') {
                                            this.filePath = data['entityname'] + '/src/test/java/' + packagepath + '/' + this.fileName;
                                        } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                                            this.filePath = this.filePath + data['entityname'] + '/src/test/java/' + packagepath + '/' + this.fileName;
                                        } else {
                                            this.filePath = this.filePath + '/' + data['entityname'] + '/src/test/java/' + packagepath + '/' + this.fileName;
                                        }
                                    }
                                    if (i === 2) {
                                        this.filePath = this.path;
                                        this.fileName = 'application.properties';
                                        if (this.filePath === '') {
                                            this.filePath = data['entityname'] + '/src/main/resources/' + this.fileName;
                                        } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                                            this.filePath = this.filePath + data['entityname'] + '/src/main/resources/' + this.fileName;
                                        } else {
                                            this.filePath = this.filePath + '/' + data['entityname'] + '/src/main/resources/' + this.fileName;
                                        }
                                    }

                                    if (i === 3) {
                                        this.filePath = this.path;
                                        this.fileName = data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + '.java';
                                        if (this.filePath === '') {
                                            this.filePath = data['entityname'] + '/src/main/java/' + packagepath + '/model/' + this.fileName;
                                        } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                                            this.filePath = this.filePath + data['entityname'] + '/src/main/java/' + packagepath + '/model/' + this.fileName;
                                        } else {
                                            this.filePath = this.filePath + '/' + data['entityname'] + '/src/main/java/' + packagepath + '/model/' + this.fileName;
                                        }
                                    }
                                    if (i === 4) {
                                        this.filePath = this.path;
                                        this.fileName = data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + 'Repository.java';
                                        if (this.filePath === '') {
                                            this.filePath = data['entityname'] + '/src/main/java/' + packagepath + '/repository/' + this.fileName;
                                        } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                                            this.filePath = this.filePath + data['entityname'] + '/src/main/java/' + packagepath + '/repository/' + this.fileName;
                                        } else {
                                            this.filePath = this.filePath + '/' + data['entityname'] + '/src/main/java/' + packagepath + '/repository/' + this.fileName;
                                        }
                                    }
                                    if (i === 5) {
                                        this.filePath = this.path;
                                        this.fileName = data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + 'Controller.java';
                                        if (this.filePath === '') {
                                            this.filePath = data['entityname'] + '/src/main/java/' + packagepath + '/resource/' + this.fileName;
                                        } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                                            this.filePath = this.filePath + data['entityname'] + '/src/main/java/' + packagepath + '/resource/' + this.fileName;
                                        } else {
                                            this.filePath = this.filePath + '/' + data['entityname'] + '/src/main/java/' + packagepath + '/resource/' + this.fileName;
                                        }
                                    }
                                    if (i === 6) {
                                        this.filePath = this.path;
                                        this.fileName = data['entityname'].charAt(0).toUpperCase() + data['entityname'].slice(1) + 'Application.java';
                                        if (this.filePath === '') {
                                            this.filePath = data['entityname'] + '/src/main/java/' + packagepath + '/' + this.fileName;
                                        } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
                                            this.filePath = this.filePath + data['entityname'] + '/src/main/java/' + packagepath + '/' + this.fileName;
                                        } else {
                                            this.filePath = this.filePath + '/' + data['entityname'] + '/src/main/java/' + packagepath + '/' + this.fileName;
                                        }
                                    }

                                    let payload = {
                                        'account': this.data['account'],
                                        'partner': this.data['partner'],
                                        'entity_name': this.data['entityname'],
                                        'version': this.data['version'],
                                        'repository_path': this.repoPath,
                                        'branch': this.selectedBranch,
                                        'path': this.filePath,
                                        'file_name': this.fileName,
                                        'code': this.selectedCode,
                                        'commit_message': this.commitMessage
                                    };

                                    this.confPost.commitToGitHub(this.data['account'], this.accessToken, this.selectedBranch, this.repoPath, this.filePath, this.fileName, btoa(generatedCode[i]), this.commitMessage).subscribe(res => {
                                        if (i === 3) {
                                            this.isCommitted = true;
                                            loaderDialog.close();
                                            this.committedFilePath = res['content']['html_url'];
                                            payload['file_path'] = this.committedFilePath;
                                            payload['commit_path'] = res['commit']['html_url'];
                                            payload['author'] = res['commit']['author']['email'];
                                            payload['commit_date'] = res['commit']['author']['date'];
                                            payload['sha'] = res['content']['sha'];
                                            payload['attributes'] = JSON.stringify(data['attributes']);
                                            this.author = res['commit']['author']['email'];
                                            this.committedDate = res['commit']['author']['date'];
                                            this.commitPath = res['commit']['html_url'];

                                            this.confPost.addItemServices('v1', 'githubCommits', payload).subscribe(res => {
                                            });
                                        }
                                    }, err => {
                                        loaderDialog.close();
                                        this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    });
                                },
                                i * 1000);
                        }
                    }
                } else {
                    if (this.selectedCode === 'Python') {
                        this.confPost.mergeToGitHub(this.data['account'], this.accessToken, this.selectedBranch, this.committedRepoPath, this.committedPath, this.committedFileName, btoa(generatedCode[0]), this.committedSha, this.commitMessage).subscribe(res => {
                            this.isCommitted = true;
                            this.isRedeployed = false;
                            loaderDialog.close();
                            this.committedFilePath = res['content']['html_url'];
                            const payload = {
                                'account': this.data['account'],
                                'partner': this.data['partner'],
                                'entity_name': this.data['entityname'],
                                'version': this.data['version'],
                                'file_path': res['content']['html_url'],
                                'commit_path': res['commit']['html_url'],
                                'author': res['commit']['author']['email'],
                                'commit_date': res['commit']['author']['date'],
                                'sha': res['content']['sha'],
                                'attributes': JSON.stringify(data['attributes']),
                                'repository_path': this.committedRepoPath,
                                'branch': this.selectedBranch,
                                'path': this.committedPath,
                                'file_name': this.fileName,
                                'code': this.selectedCode,
                                'commit_message': this.commitMessage
                            };
                            this.author = res['commit']['author']['email'];
                            this.committedDate = res['commit']['author']['date'];
                            this.commitPath = res['commit']['html_url'];

                            this.confPost.addItemServices('v1', 'githubCommits', payload).subscribe(res => {
                            });
                        }, err => {
                            loaderDialog.close();
                            this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                    } else if (this.selectedCode === 'Java') {
                        this.confPost.mergeToGitHub(this.data['account'], this.accessToken, this.selectedBranch, this.committedRepoPath, this.committedPath, this.committedFileName, btoa(generatedCode[3]), this.committedSha, this.commitMessage).subscribe(res => {
                            this.isCommitted = true;
                            this.isRedeployed = false;
                            loaderDialog.close();
                            this.committedFilePath = res['content']['html_url'];
                            const payload = {
                                'account': this.data['account'],
                                'partner': this.data['partner'],
                                'entity_name': this.data['entityname'],
                                'version': this.data['version'],
                                'file_path': res['content']['html_url'],
                                'commit_path': res['commit']['html_url'],
                                'author': res['commit']['author']['email'],
                                'commit_date': res['commit']['author']['date'],
                                'sha': res['content']['sha'],
                                'attributes': JSON.stringify(data['attributes']),
                                'repository_path': this.committedRepoPath,
                                'branch': this.selectedBranch,
                                'path': this.committedPath,
                                'file_name': this.fileName,
                                'code': this.selectedCode,
                                'commit_message': this.commitMessage
                            };
                            this.author = res['commit']['author']['email'];
                            this.committedDate = res['commit']['author']['date'];
                            this.commitPath = res['commit']['html_url'];

                            this.confPost.addItemServices('v1', 'githubCommits', payload).subscribe(res => {
                            });
                        }, err => {
                            loaderDialog.close();
                            this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });


                    }
                }
            }
        }, err1 => {
            this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    commitAgain() {
        this.isCommitted = false;
    }

    copyMessage(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        // selBox.value = $(val).text();
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.platform.openSnackBar('Copied to clipboard.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    close() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'endpoint-view',
    templateUrl: 'endpoint.component.html',
    styleUrls: ['endpoint.component.css']
})
export class EndpointComponent implements OnInit {
    apiKey = localStorage.getItem('apikey');
    apiExecutor: any;
    loading = true;
    entityMethods: any;
    isExpanded = false;
    selectedExecutor: any;

    constructor(
        private confPost: ConfService, public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<EndpointComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnInit() {
        if (this.data['type'] === 'entity') {
            this.entityMethods = [];
            this.confPost.getEntity(this.data['partner'], this.data['account'], this.data['entity'], this.data['version']).subscribe(resp => {
                if (resp && resp !== undefined && resp !== null && resp['methods'] && resp['methods'] !== null && resp['methods'] !== undefined) {
                    this.entityMethods = resp['methods'];
                    this.loading = false;
                } else {
                    this.entityMethods = [];
                    this.loading = false;
                }
            }, error => {
                this.entityMethods = [];
                this.platform.openSnackBar('Error in retrieving entity methods. Please try again sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
            });
        } else {
            this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.data['partner'], this.data['account'], this.data['entity'], this.data['version']).subscribe(response => {
                this.apiExecutor = response;
                this.selectedExecutor = response['executor_method_type'];
                this.loading = false;
            }, error => {
                this.platform.openSnackBar('Error in retrieving APIs. Please try again sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
            });
        }
    }

    close() {
        this.dialogRef.close();
    }

    toggleExecutor(ev) {
        $('.more-query-options').slideToggle();
        this.isExpanded = !this.isExpanded;
    }

    createAccount(result) {
        this.confPost.insertAccount(localStorage.getItem('partner'), result).subscribe(data => {
            this.platform.openSnackBar('Account created successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while creating account' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    copyInputMessage(inputElement) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
    }

    copyText(val) {
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(val).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.platform.openSnackBar('CURL command copied to clipboard.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
        // alert('CURL command copied to clipboard');
    }

    copyMessage(event) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(event.target).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.platform.openSnackBar('CURL command copied to clipboard.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }
}

@Component({
    selector: 'metrics-view',
    templateUrl: 'metrics.component.html',
    styleUrls: ['metrics.component.css']
})
export class MetricsComponent {
    apiHitsTrendResult: any;
    apiLatencyTrendResult: any;

    constructor(
        private confPost: ConfService,
        public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<MetricsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    close() {
        this.dialogRef.close();
    }

    ngOnInit() {
        // let dataPoints = [];
        // let latencyDataPoints = [];
        // let dpsLength = 0;
        // this.confPost.getCloudWatchMetricsTrend(localStorage.getItem('partner'), localStorage.getItem('account'), this.data['entity'], this.data['version']).subscribe(data => {
        //     this.apiHitsTrendResult = data;
        //     this.apiHitsTrendResult.forEach((trend) => {
        //         dataPoints.push({x: new Date(trend.Timestamp), y: trend.Sum});
        //         dpsLength = trend.length;
        //     });
        //     let chart = new CanvasJS.Chart('apiTotalHitsTrendChartContainer', {
        //         animationEnabled: true,
        //         exportEnabled: false,
        //         title: {
        //             text: 'Weekly Trend: No. of API Hits'
        //         },
        //         data: [{
        //             type: 'line',
        //             dataPoints: dataPoints
        //         }]
        //     });
        //     chart.render();
        // });
        //
        // this.confPost.getCloudWatchMetricsLatencyTrend(localStorage.getItem('partner'), localStorage.getItem('account'), this.data['entity'], this.data['version']).subscribe(data => {
        //     this.apiLatencyTrendResult = data;
        //     this.apiLatencyTrendResult.forEach((trend) => {
        //         latencyDataPoints.push({x: new Date(trend.Timestamp), y: trend.Average});
        //         dpsLength = trend.length;
        //     });
        //     let latencyChart = new CanvasJS.Chart('apiAverageLatencyTrendChartContainer', {
        //         animationEnabled: true,
        //         exportEnabled: false,
        //         title: {
        //             text: 'Weekly Trend: Average Response Time'
        //         },
        //         data: [{
        //             type: 'line',
        //             dataPoints: latencyDataPoints
        //         }]
        //     });
        //     latencyChart.render();
        // });
    }

}

@Component({
    selector: 'create-service-confirmation',
    templateUrl: 'create-service-confirmation.component.html',
    styleUrls: ['create-service-confirmation.component.css']
})
export class CreateGatewayResourceConfirmationComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}

@Component({
    selector: 'mode-of-access-confirmation',
    templateUrl: 'mode-of-access-confirmation.component.html',
    styleUrls: ['mode-of-access-confirmation.component.css']
})
export class ModeOfAccessConfirmationComponent implements OnInit {

    isPluginAvailable = true;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        if (this.data && this.data.hasOwnProperty('isPluginAvailable')) {
            this.isPluginAvailable = this.data.isPluginAvailable;
        }
    }

}

@Component({
    selector: 'publish-service-confirmation',
    templateUrl: 'publish-service-confirmation.component.html',
    styleUrls: ['publish-service-confirmation.component.css']
})
export class PublishServiceConfirmationComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}

@Component({
    selector: 'activate-service-confirmation',
    templateUrl: 'activate-service-confirmation.component.html',
    styleUrls: ['activate-service-confirmation.component.css']
})
export class ActivateServiceConfirmationComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}

@Component({
    selector: 'secure-api-confirmation',
    templateUrl: 'secure-api-confirmation.component.html',
    styleUrls: ['secure-api-confirmation.component.css']
})
export class SecureApiConfirmationComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}
